/* ============================================================
 * FIA client-side error logger
 * Sends browser-side auth failures (network/CORS/JS errors and
 * non-OK responses) to the backend so they land in the SAME
 * audit_logs table the admin panel reads. Defines
 * window.fiaLogClientError(context, details) used further below.
 * ============================================================ */
(function () {
    var CLIENT_LOG_URL =
        '/api/ai/clientLog';

    // Fire-and-forget. Never throws, never blocks the page.
    window.fiaLogClientError = function (context, details) {
        try {
            details = details || {};
            var payload = {
                context:    String(context || 'unknown'),
                message:    String(details.message || 'No message'),
                httpStatus: typeof details.httpStatus === 'number' ? details.httpStatus : null,
                email:      details.email ? String(details.email) : null,
                errorName:  details.errorName ? String(details.errorName) : null,
                url:        window.location ? window.location.href : null,
                detail:     details.detail
                    ? String(details.detail).replace(/(password|pwd)["':=\s]+\S+/gi, '$1=[redacted]').slice(0, 500)
                    : null
            };
            var body = JSON.stringify(payload);

            // The report has to survive the very failure it describes.
            // application/json is not a CORS-safelisted content type, so it
            // forces a preflight — and the platform layer in front of the
            // backend answers OPTIONS with 400 for any origin outside its
            // allowlist. The request then never leaves the browser and the
            // failure is invisible on both sides (this is why FRONTEND_ERROR
            // stayed empty for months while sendBeacon was the primary path).
            // text/plain IS safelisted, so this POST is a "simple request":
            // no preflight, it always reaches the server. The blocked response
            // does not matter — nothing here reads it. The backend parses the
            // body regardless of content type.
            if (window.fetch) {
                fetch(CLIENT_LOG_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
                    body: body,
                    keepalive: true
                }).catch(function () {});
            } else if (navigator.sendBeacon) {
                navigator.sendBeacon(CLIENT_LOG_URL, new Blob([body], { type: 'text/plain' }));
            }
        } catch (e) {
            if (window.console && console.warn) console.warn('fiaLogClientError failed:', e);
        }
    };

    // A jQuery/fetch failure carrying no HTTP status at all means the request
    // never completed at the network/CORS layer: rejected preflight, blocked
    // host, dropped connection. That is not a rejected email or password, so
    // "please try again" is wrong advice — a retry cannot help.
    window.FIA_UNREACHABLE_MESSAGE =
        "We couldn't reach the FIA Documentation service from your network. " +
        'This is not a problem with your details — please contact sjones@fia.org.';

    window.fiaIsUnreachable = function (err) {
        return !err || !err.status;
    };

    // Catch uncaught errors, but only on auth pages to avoid site-wide noise.
    var path = (window.location && window.location.pathname) || '';
    var isAuthPage =
        path.indexOf('/login') > -1 ||
        path.indexOf('registr') > -1 ||
        path.indexOf('register') > -1 ||
        path.indexOf('reset') > -1;
    if (isAuthPage) {
        window.addEventListener('error', function (event) {
            window.fiaLogClientError('global', {
                message:   (event && event.message) || 'window.onerror',
                errorName: (event && event.error && event.error.name) || 'Error',
                detail:    event && event.filename ? event.filename + ':' + event.lineno + ':' + event.colno : null
            });
        });
        window.addEventListener('unhandledrejection', function (event) {
            var reason = event && event.reason;
            window.fiaLogClientError('global', {
                message:   (reason && reason.message) || 'unhandledrejection',
                errorName: (reason && reason.name) || 'UnhandledRejection'
            });
        });
    }
})();

jQuery(document).ready(function ($) {

    //Slick Slider

    $('.about-slider').each(function(){
        $(this).slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            // Insert your SVG here
            prevArrow: '<button type="button" class="slick-prev"><svg width="26" height="41" viewBox="0 0 26 41" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<rect x="0.305664" y="0.175537" width="24.9878" height="40.5358" rx="4" fill="#294661" fill-opacity="0.5"/>\n' +
                '<path d="M16.7497 8.49927L19.8678 11.6174L8.17479 23.3105L5.05664 20.1923L16.7497 8.49927Z" fill="white"/>\n' +
                '<path d="M19.8678 28.7672L16.7497 31.8854L5.05664 20.1923L8.17479 17.0742L19.8678 28.7672Z" fill="white"/>\n' +
                '<rect x="0.305664" y="0.175537" width="24.9878" height="40.5358" rx="4" fill="#294661"/>\n' +
                '<path d="M16.7497 8.49927L19.8678 11.6174L8.17479 23.3105L5.05664 20.1923L16.7497 8.49927Z" fill="white"/>\n' +
                '<path d="M19.8678 28.7672L16.7497 31.8854L5.05664 20.1923L8.17479 17.0742L19.8678 28.7672Z" fill="white"/>\n' +
                '</svg>\n</button>',
            nextArrow: '<button type="button" class="slick-next"><svg width="26" height="41" viewBox="0 0 26 41" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<rect x="0.307617" y="0.174316" width="24.9878" height="40.5358" rx="4" fill="#294661" fill-opacity="0.5"/>\n' +
                '<path d="M9.00975 8.49902L5.8916 11.6172L17.5847 23.3102L20.7028 20.1921L9.00975 8.49902Z" fill="white"/>\n' +
                '<path d="M5.8916 28.767L9.00975 31.8851L20.7028 20.1921L17.5847 17.0739L5.8916 28.767Z" fill="white"/>\n' +
                '<rect x="0.307617" y="0.174316" width="24.9878" height="40.5358" rx="4" fill="#294661"/>\n' +
                '<path d="M9.00975 8.49902L5.8916 11.6172L17.5847 23.3102L20.7028 20.1921L9.00975 8.49902Z" fill="white"/>\n' +
                '<path d="M5.8916 28.767L9.00975 31.8851L20.7028 20.1921L17.5847 17.0739L5.8916 28.767Z" fill="white"/>\n' +
                '</svg>\n</button>'
        });
    });
    //

    $('#search-icon').on('click', function (e) {
        e.preventDefault();

        $(this).hide();

        $('#search-wrapper').show().addClass('d-flex');
        $('#search-button, #search-input').show();

        setTimeout(function() {
            $('#search-wrapper').addClass('active');
            $('#search-input').focus();
        }, 20);
    });

// Jurisdictions
    const wrapper = document.querySelector('.hero-jurisdictions');
    const header = document.querySelector('.juris-header');

    if (header) {
        header.addEventListener('click', function(e) {
            wrapper.classList.toggle('active');
        });

        document.addEventListener('click', function(e) {
            if (!wrapper.contains(e.target)) {
                wrapper.classList.remove('active');
            }
        });
    }
//

    // Front Switch BTN

    $(document).on('click', '.accordion-header', function(e) {
        const $item = $(this).closest('.accordion-item');

        // A country with a single card is not collapsible: it has no chevron, and
        // the stylesheet holds it open. Without this the title would still toggle
        // `active` on click — invisible on screen, but it would leave the one
        // control that can reopen it absent.
        if ($item.hasClass('single-card')) {
            return;
        }

        $item.toggleClass('active');

        if ($item.hasClass('active')) {
            $('#collapse-all-toggle').prop('checked', false);
        }
    });

    $('#collapse-all-toggle').on('change', function() {
        const isChecked = $(this).is(':checked');
        if (isChecked) {
            $('.accordion-item').removeClass('active');
        } else {
            $('.accordion-item').addClass('active');
        }
    });

    $(document).on('click', '.mini-header', function(e) {
        e.stopPropagation();
        $(this).closest('.mini-accordion').toggleClass('active');
    })

});






// AI Chat - Professional Sidebar Transformation
jQuery(document).ready(function($) {

    function enableChatInput() {
        $input
            .prop('disabled', false)
            .removeAttr('disabled')
            .attr('placeholder', 'Write a message...')
            .css({
                opacity: '1',
                pointerEvents: 'auto',
                cursor: 'text',
                backgroundColor: '',
                color: ''
            })
            .focus();

        $sendBtn
            .prop('disabled', false)
            .removeAttr('disabled')
            .css({
                opacity: '1',
                pointerEvents: 'auto',
                cursor: 'pointer'
            });
        // CHANGED: Unlock the fixed summarization button when AI response is ready
        $('#ai-summarize-btn-fixed').prop('disabled', false);
    }
    // --- SECURITY & DYNAMIC CLEANUP ---
    const token = localStorage.getItem('authToken');
    const isWpLoggedIn = $('body').hasClass('logged-in');

    window.clearAiChatData = function() {
        localStorage.removeItem('ai_chat_history_html');
        localStorage.removeItem('ai_chat_session_id');
        localStorage.removeItem('ai_chat_is_open');
        window.currentConversationId = null;
        if ($('#ai-chat-messages').length) {
            clearChatSession();
        }
    };


    if (!token || !isWpLoggedIn) {
        console.warn("Auth token missing or expired. Cleaning data, but keeping UI active.");
        localStorage.removeItem('ai_chat_history_html');
        localStorage.removeItem('ai_chat_session_id');
    }



    // Protect Xss attacks
    function escapeHtml(text) {
        const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
        return String(text).replace(/[&<>"']/g, function(m) { return map[m]; });
    }

    const historyIconSvg = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12L15 15" stroke="#294661" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.05 11C3.24524 9.40011 3.89679 7.9048 4.92211 6.7022C5.94743 5.49961 7.29742 4.64653 8.80214 4.25141C10.3069 3.85628 11.8927 3.93724 13.3606 4.48417C14.8285 5.03109 16.1044 6.01757 17.027 7.31934C17.9496 8.62111 18.4746 10.1742 18.5358 11.7825C18.597 13.3908 18.1915 14.9748 17.3711 16.3331C16.5507 17.6914 15.3541 18.7573 13.9332 19.3957C12.5123 20.034 10.9333 20.214 9.39999 19.91" stroke="#294661" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 5V11H9" stroke="#294661" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    window.currentConversationId = localStorage.getItem('ai_chat_session_id') || null;
    let currentAjaxRequest = null;
    const apiBase = '/api/ai/chat';

    const fiaLogoSvg = `<svg class="assistant-logo" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#294661"/><g clip-path="url(#clip0_414_1870)"><path d="M15.5445 16.2265V12.5713H5.71436V26.8459H9.49306V22.1427H14.1854V18.4632H9.49306V16.2265H15.5445Z" fill="white"/><path d="M19.9879 19.6421V12.5713H16.2334V26.8455H17.1369L19.9879 19.6421Z" fill="white"/><path d="M23.0326 13.1582L17.6152 26.846H21.5549L25.0023 18.1352L23.0326 13.1582Z" fill="white"/><path d="M30.9761 20.8926L32.2363 24.0762L33.445 20.8926H30.9761Z" fill="white"/><path d="M27.2043 12.5713H23.2646L26.558 20.8922H25.2006L23.696 24.6927H28.0622L28.9142 26.8455H32.8539L27.2043 12.5713Z" fill="white"/></g></svg>`;

    const $input = $('#ai-user-input');
    const $chatMessages = $('#ai-chat-messages');
    const $chatWindow = $('#ai-chat-window');
    const $sendBtn = $('#ai-send-btn');
    const $launcher = $('#ai-chat-launcher');
    const $html = $('html');
    const $body = $('body');

    // --- RESTORE STATE ON LOAD ---
    const savedContent = localStorage.getItem('ai_chat_history_html');

    if (token && savedContent && $chatMessages.length) {
        $chatMessages.html(savedContent);
        setTimeout(scrollToBottom, 150);
    } else {
        clearChatSession();
    }

    // --- SIDEBAR INITIALIZATION & HISTORY ---
    $(document).on('click', '#ai-history-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const isFullScreen = $chatWindow.hasClass('full-screen');

        if (!isFullScreen) {
            setFullScreen(true);
            $chatWindow.addClass('history-open');
        } else {
            $chatWindow.toggleClass('history-open');
        }

        if ($chatWindow.hasClass('history-open')) {
            $('.chevron').addClass('rotated');
            loadConversations();
        } else {
            $('.chevron').removeClass('rotated');
        }

        window.dispatchEvent(new Event('resize'));
    });


    // --- STATE FOR INFINITE SCROLL ---
    let historySkip = 0;
    const historyLimit = 100;
    let isLoadingHistory = false;
    let hasMoreHistory = true;

    window.loadConversations = async function(append = false) {
        const $list = $('#ai-conversations-list');
        if (!$list.length || isLoadingHistory) return;
        if (append && !hasMoreHistory) return;

        const token = localStorage.getItem('authToken');
        if (!token) return;

        const hasExistingContent = $list.find('.conv-item').length > 0;

        if (!append) {
            historySkip = 0;
            hasMoreHistory = true;

            if (!hasExistingContent) {
                $list.html('<div class="p-3 text-center opacity-50">Syncing...</div>');
            }
        } else {
            $list.append('<div id="history-loader" class="p-2 text-center opacity-50">Loading more...</div>');
        }

        isLoadingHistory = true;

        try {
            const response = await $.ajax({
                url: `${apiBase}/getConversations?limit=${historyLimit}&skip=${historySkip}`,
                type: 'GET',
                headers: { 'Authorization': 'Bearer ' + token }
            });

            if (response.success && response.result.conversations) {
                const convs = response.result.conversations;

                const buildConvItem = (conv) => {
                    const activeClass = conv.id === window.currentConversationId ? 'active' : '';
                    const relTime = formatRelativeTime(conv.lastMessageAt);
                    const timeHtml = relTime
                        ? `<span class="conv-time">${relTime}</span>`
                        : '';
                    return `
                            <div class="conv-item ${activeClass}" data-id="${conv.id}">
                                <div class="conv-main">
                                    <span class="conv-title">${escapeHtml(conv.title)}</span>
                                    ${timeHtml}
                                </div>
                                <div class="conv-actions">
                                    <button class="conv-menu-btn">•••</button>
                                    <div class="conv-dropdown">
                                        <div class="conv-delete-opt" data-id="${conv.id}">Delete</div>
                                    </div>
                                </div>
                            </div>`;
                };

                if (!append) {
                    if (convs.length === 0) {
                        $list.html('<div class="p-3 text-center opacity-50">No history yet</div>');
                    } else {
                        let newHtml = '';
                        convs.forEach(conv => {
                            newHtml += buildConvItem(conv);
                        });

                        $list.html(newHtml);
                    }
                } else {
                    $('#history-loader').remove();
                    let appendHtml = '';
                    convs.forEach(conv => {
                        appendHtml += buildConvItem(conv);
                    });
                    $list.append(appendHtml);
                }

                historySkip += convs.length;
                hasMoreHistory = convs.length >= historyLimit;
            }
        } catch (e) {
            console.error("History API Error:", e);
        } finally {
            isLoadingHistory = false;
            $('#history-loader').remove();
        }
    };

    $(document).on('click', '.conv-menu-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.conv-dropdown').not($(this).next()).removeClass('show');
        $(this).next('.conv-dropdown').toggleClass('show');
    });

    $(document).on('click', function() {
        $('.conv-dropdown').removeClass('show');
    });

    let conversationToDelete = null;

    $(document).on('click', '.conv-delete-opt', function(e) {
        e.preventDefault();
        e.stopPropagation();

        conversationToDelete = $(this).data('id');
        $('#ai-delete-modal').css('display', 'flex').hide().fadeIn(200);
        $('.conv-dropdown').removeClass('show');
    });


    $('#ai-modal-cancel').on('click', function() {
        $('#ai-delete-modal').fadeOut(200);
        conversationToDelete = null;
    });


    $('#ai-modal-confirm').on('click', async function() {
        if (!conversationToDelete) return;

        const token = localStorage.getItem('authToken');
        const convId = conversationToDelete;

        try {
            const response = await $.ajax({
                url: `${apiBase}/deleteConversation`,
                type: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({ conversationId: convId })
            });

            if (response.success) {
                if (convId === window.currentConversationId) {
                    clearChatSession();
                    saveChatState();
                }
                loadConversations();
            }
        } catch (e) {
            console.error("Delete Error:", e);
        } finally {
            $('#ai-delete-modal').fadeOut(200);
            conversationToDelete = null;
        }
    });

    async function openConversation(id) {
        window.currentConversationId = id;
        localStorage.setItem('ai_chat_session_id', id);

        $chatMessages.html('<div class="ai-loading">Loading messages...</div>');
        $('.welcome-section, .welcome-card').remove();

        try {
            const response = await $.ajax({
                url: `${apiBase}/getMessages?conversationId=${id}&limit=50`,
                type: 'GET',
                headers: { 'Authorization': 'Bearer ' + localStorage.getItem('authToken') }
            });

            if (response.success) {
                $chatMessages.empty();
                response.result.messages.forEach(msg => {
                    appendMessage(msg.text, msg.isQuestion ? 'user' : 'assistant', msg.sources, msg.createdAt);
                });
                saveChatState();
                scrollToBottom();

                $('.conv-item').removeClass('active');
                $(`.conv-item[data-id="${id}"]`).addClass('active');
            }
        } catch (e) {
            $chatMessages.append('<p class="p-3 text-danger">Error loading conversation history.</p>');
        }
    }

    // --- HELPER FUNCTIONS ---
    function saveChatState() {
        if ($chatMessages.length) {
            localStorage.setItem('ai_chat_history_html', $chatMessages.html());
        }
        if (window.currentConversationId) {
            localStorage.setItem('ai_chat_session_id', window.currentConversationId);
        }
    }

    function clearChatSession() {
        localStorage.removeItem('ai_chat_history_html');
        localStorage.removeItem('ai_chat_session_id');
        localStorage.removeItem('ai_chat_is_open');
        window.currentConversationId = null;

        if (currentAjaxRequest) {
            currentAjaxRequest.abort();
            currentAjaxRequest = null;
        }

        localStorage.removeItem('ai_chat_history_html');
        localStorage.removeItem('ai_chat_session_id');

        window.currentConversationId = null;


        const welcomeHTML = `
<div class="welcome-section">
    <div class="welcome-card-window">
        <div class="fia-logo-circle">
            <img src="/wp-content/themes/understrap-child-main/img/Grey-Logo-FIA.svg" alt="FIA">
        </div>
        <div class="welcome-text">
            <p>Hello! Nice to meet you.<br>Ask about FIA legal documents<br>I use FIA sources only — with citations.</p>
            <p class="disclaimer">Information is limited to the provided FIA documentation. Not for legal or financial decisions.</p>
        </div>
        <div class="mini-welcome-actions">
            <span class="fia-trigger-page-summary qa-button-style" style="cursor: pointer; background: #f8fbff; border: 1px dashed #294661; padding: 10px 16px; border-radius: 6px; display: inline-block; font-size: 14px; line-height: 1.2;">
                Summarize current page
            </span>
        </div>
    </div>

    <div class="welcome-layout-full">
        <div class="chat-icon-main">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.3333 16.6665H13.35M20 16.6665H20.0167M26.6667 16.6665H26.6833M15 26.6665H8.33333C7.44928 26.6665 6.60143 26.3153 5.97631 25.6902C5.35119 25.0651 5 24.2172 5 23.3332V9.99984C5 9.11578 5.35119 8.26794 5.97631 7.64281C6.60143 7.01769 7.44928 6.6665 8.33333 6.6665H31.6667C32.5507 6.6665 33.3986 7.01769 34.0237 7.64281C34.6488 8.26794 35 9.11578 35 9.99984V23.3332C35 24.2172 34.6488 25.0651 34.0237 25.6902C33.3986 26.3153 32.5507 26.6665 31.6667 26.6665H23.3333L15 34.9998V26.6665Z" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <h2>Welcome to AI Chat</h2>
        <p class="description">Hello! Nice to meet you. Ask about FIA legal documents<br>I use FIA sources only — with citations.</p>
        <br>
        <p class="disclaimer">Information is limited to the provided FIA documentation. Not for legal or financial decisions.</p>
        <br>
        <div class="quick-actions-grid">
            <span class="fia-trigger-page-summary qa-button-style" style="cursor: pointer; background: #294661; color: white; padding: 12px 20px; border-radius: 8px; text-align: center; display: block;"> 
                Summarize current page 
            </span>
        </div>
    </div>
</div>`;


        // $('#ai-chat-messages').html(welcomeHTML);
        $('#ai-user-input').val('').css('height', 'auto');

        const $messagesContainer = $('#ai-chat-messages');
        if ($messagesContainer.length) {
            $messagesContainer.empty().html(welcomeHTML);
            $messagesContainer.scrollTop(0);
        }
    }

    function getCurrentTime() {
        return new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    }

    // Parse a server timestamp (ISO-8601, e.g. "2026-07-14T08:40:00.000Z") or a
    // naive UTC SQL datetime ("2026-07-14 08:40:00") into a Date. Returns null if
    // the value is missing or unparseable.
    function parseServerDate(value) {
        if (!value) return null;
        let s = String(value).trim();
        if (!s) return null;
        // Naive "YYYY-MM-DD HH:MM:SS" is stored as UTC -> normalize and mark as UTC.
        if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}/.test(s) && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
            s = s.replace(' ', 'T') + 'Z';
        }
        const d = new Date(s);
        return isNaN(d.getTime()) ? null : d;
    }

    // Absolute clock time (e.g. "08:40 AM") for a message, from a real server
    // timestamp. Falls back to the current time when none is available.
    function formatMessageTime(value) {
        const d = parseServerDate(value);
        return (d || new Date()).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    }

    // Relative "time ago" label for the Chat History list: "just now", "5m ago",
    // "2h ago", "3d ago", "1w ago", or a date for anything older.
    function formatRelativeTime(value) {
        const d = parseServerDate(value);
        if (!d) return '';

        let diffSec = Math.floor((Date.now() - d.getTime()) / 1000);
        if (diffSec < 0) diffSec = 0; // guard against minor clock skew

        if (diffSec < 60) return 'just now';

        const diffMin = Math.floor(diffSec / 60);
        if (diffMin < 60) return `${diffMin}m ago`;

        const diffHour = Math.floor(diffMin / 60);
        if (diffHour < 24) return `${diffHour}h ago`;

        const diffDay = Math.floor(diffHour / 24);
        if (diffDay < 7) return `${diffDay}d ago`;

        const diffWeek = Math.floor(diffDay / 7);
        if (diffWeek < 5) return `${diffWeek}w ago`;

        const diffMonth = Math.floor(diffDay / 30);
        if (diffMonth < 12) return `${diffMonth}mo ago`;

        return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }


    function scrollToBottom() {
        if ($chatMessages.length) {
            $chatMessages.stop().animate({ scrollTop: $chatMessages[0].scrollHeight }, 300);
        }
    }

    function showAuthError() {
        const html = `
            <div class="ai-chat-error-overlay auth-error-container">
                <div class="ai-chat-error-bubble">
                    <p>Please log in to use the AI Assistant functional.</p>
                    <a href="/login" class="ai-auth-redirect-btn">Log In</a>
                </div>
            </div>`;
        $chatMessages.append(html);
        scrollToBottom();
        $input.prop('disabled', true).attr('placeholder', 'Authentication required...');
        $sendBtn.prop('disabled', true).css('opacity', '0.5');
    }

    function toggleSidebar(open) {
        const $header = $('#wrapper-navbar, header, .site-header');
        if (open) {
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            $html.addClass('ai-chat-sidebar-active');
            if (scrollBarWidth > 0) {
                $body.css('padding-right', scrollBarWidth + 'px');
                $header.css('padding-right', scrollBarWidth + 'px');
            }
            $launcher.fadeOut(200);
            $chatWindow.stop().fadeIn(200).css('display', 'flex');
            localStorage.setItem('ai_chat_is_open', 'true');
            loadConversations();
        } else {
            setFullScreen(false);

            $html.removeClass('ai-chat-sidebar-active');
            $chatWindow.stop().fadeOut(200);
            $launcher.fadeIn(200);
            localStorage.setItem('ai_chat_is_open', 'false');
            $body.css({'padding-right': ''});
            $header.css({'padding-right': ''});
        }
        setTimeout(() => { window.dispatchEvent(new Event('resize')); scrollToBottom(); }, 350);
    }

    function setFullScreen(enable) {
        const container = $chatMessages[0];
        const isAtBottom = Math.abs(container.scrollHeight - container.clientHeight - container.scrollTop) < 100;
        if (enable) {
            $chatWindow.addClass('full-screen');
            $html.addClass('full-screen-active');
        } else {
            $chatWindow.removeClass('full-screen');
            $chatWindow.removeClass('history-open');
            $html.removeClass('full-screen-active');
        }
        setTimeout(() => {
            if (isAtBottom) container.scrollTop = container.scrollHeight;
            window.dispatchEvent(new Event('resize'));
        }, 310);
    }


    // Configuration
    const RETRY_CONF = {
        maxAttempts: 5,
        delayMs: 2000
    };

    /* ── Connection loss while an answer is in flight ──────────────────────
     * The job keeps running on the server while the browser is offline, so a
     * dropped connection is not a lost answer. Say so, keep waiting, and
     * resume the same job the moment the network is back. Only when there is
     * nothing left to resume does this become an error the user must act on.
     * ------------------------------------------------------------------- */
    const CONNECTION_NOTICE_ID = 'ai-connection-notice';
    // Offline polls must not eat the 60-attempt (3 min) answer budget, so they
    // are counted separately. ~5 minutes of outage before we give up on a job.
    const MAX_NETWORK_FAILURES = 100;

    // jQuery reports an unreachable network as status 0. navigator.onLine
    // covers the case where the request never leaves the browser at all.
    function isNetworkFailure(error) {
        return !navigator.onLine || !error || !error.status;
    }

    // One notice at a time, replaced rather than stacked: an outage that spans
    // twenty poll attempts must not print twenty bubbles.
    function showConnectionNotice(text) {
        clearConnectionNotice();
        $chatMessages.append(`
        <div class="message-wrapper assistant" id="${CONNECTION_NOTICE_ID}">
            <div class="message assistant" style="color:#8a6d3b; border:1px solid #f0ad4e; background:#fcf8e3;">
                ${text}
            </div>
        </div>`);
        scrollToBottom();
    }

    function clearConnectionNotice() {
        $(`#${CONNECTION_NOTICE_ID}`).remove();
    }

    // An error the user can do something about. The button is the part the QA
    // card asks for: without it a failed answer is a dead end.
    function showRetryableError(text, onRetry) {
        const id = 'ai-retry-' + Date.now();
        $chatMessages.append(`
        <div class="message-wrapper assistant" id="${id}">
            <div class="message assistant" style="color:#d9534f; border:1px solid #d9534f; background:#fdf7f7;">
                <div>${text}</div>
                ${onRetry ? '<button type="button" class="ai-retry-btn" style="margin-top:8px; padding:6px 14px; border:1px solid #294661; border-radius:6px; background:#294661; color:#fff; cursor:pointer;">Retry</button>' : ''}
            </div>
        </div>`);

        if (onRetry) {
            $(`#${id}`).find('.ai-retry-btn').one('click', function() {
                $(`#${id}`).remove();
                onRetry();
            });
        }

        scrollToBottom();
    }

    // --- SECURITY CONFIG ---
    const SECURITY_CONF = {
        maxChars: 1500,
        cooldownMs: 3000,
        lastSent: 0,
        forbiddenPatterns: [
            /ignore (all )?previous/i,
            /disregard (all )?instructions/i,
            /system (prompt|message|instruction)/i,
            /act as a (developer|hacker|linux terminal)/i,
            /you are now (a|an) /i,
            /reveal (your )?secret/i,
            /forgot (everything|your rules)/i,
            /DAN mode/i
        ],
    };




    // --- SEND MESSAGE (Asynchronous Version with Polling Limit) ---
    async function sendMessage() {
        // 1. Force read actual ID
        let activeId = window.currentConversationId || localStorage.getItem('ai_chat_session_id');

        // Cleanup ID storage strings
        if (activeId === 'null' || activeId === 'undefined' || !activeId) {
            activeId = null;
        }

        const text = $input.val().trim();

        // Prevent empty messages or spam during processing
        if (!text || $input.prop('disabled')) return;

        // --- SECURITY & AUTH ---
        const now = Date.now();
        if (now - SECURITY_CONF.lastSent < SECURITY_CONF.cooldownMs) return;
        SECURITY_CONF.lastSent = now;

        const token = localStorage.getItem('authToken');
        if (!token) {
            showAuthError();
            return;
        }

        // --- UI CLEANUP ---
        $('.welcome-section, .welcome-card').remove();
        if (currentAjaxRequest) currentAjaxRequest.abort();

        // Stamp the user's message with the real send-time (now), so the shown
        // time is when the question was sent, not when the answer arrives.
        appendMessage(text, 'user', [], new Date().toISOString());
        saveChatState();
        scrollToBottom();

        await dispatchMessage(text, activeId);
    }

    // Everything after the user's message is already on screen: lock the UI,
    // fire the request, hand off to polling. Split out of sendMessage so that
    // a Retry button can repeat exactly this send without re-appending the
    // user's message or re-running the cooldown and security checks.
    async function dispatchMessage(text, activeId) {
        const token = localStorage.getItem('authToken');

        clearConnectionNotice();

        // LOCK UI: User cannot send next message until ID is confirmed
        $input.val('')
            .prop('disabled', true)
            .attr('placeholder', 'Thinking...')
            .css('height', '45px');
        $sendBtn.prop('disabled', true).css('opacity', '0.5');

        $('#ai-summarize-btn-fixed').prop('disabled', true);

        const typingId = 'typing-' + Date.now();
        showTypingIndicator(typingId);

        let attempts = 0;
        let success = false;

        // --- RETRY LOOP ---
        while (attempts < RETRY_CONF.maxAttempts && !success) {
            attempts++;

            try {
                const isContinuing = !!activeId;
                const url = isContinuing ? `${apiBase}/continueConversationAsync` : `${apiBase}/startConversationAsync`;

                let payload = {
                    message: text
                };

                if (isContinuing) {
                    payload.conversationId = activeId;
                }

                if (window.currentPageContextId) {
                    payload.pageContextSessionId = window.currentPageContextId;
                }

                // alert(
                //     "DEBUG INFO:\n" +
                //     "URL: " + url + "\n" +
                //     "ContextID: " + (payload.pageContextSessionId || "UNDEFINED") + "\n" +
                //     "ConversationID: " + (payload.conversationId || "NEW_CHAT")
                // );

                console.log(`[AI-DEBUG] Attempt ${attempts}/${RETRY_CONF.maxAttempts}`, payload);

                currentAjaxRequest = $.ajax({
                    url: url,
                    type: 'POST',
                    contentType: 'application/json',
                    headers: { 'Authorization': 'Bearer ' + token },
                    data: JSON.stringify(payload),
                    timeout: 45000
                });

                const response = await currentAjaxRequest;

                // The request went through, so any notice from a previous
                // attempt is stale.
                clearConnectionNotice();

                const resData = response.result || response;

                if (resData && resData.jobId) {
                    success = true; // Request successful, proceed to polling
                    pollJobResult(resData.jobId, typingId, activeId);
                } else {
                    throw new Error("Job ID missing from server response");
                }

            } catch (error) {
                if (error.statusText === 'abort') break;

                console.error(`[AI-DEBUG] Attempt ${attempts} failed:`, error);

                // Tell the user immediately, while the retries are still
                // running — silence during an outage is the reported bug.
                if (isNetworkFailure(error)) {
                    showConnectionNotice('<strong>Connection lost.</strong> Waiting for your network — we will send this as soon as you are back online.');
                }

                if (attempts >= RETRY_CONF.maxAttempts || error.status === 401 || error.status === 403) {
                    handleChatError(error, typingId, () => dispatchMessage(text, activeId));
                    enableChatInput();
                    break;
                }

                await new Promise(resolve => setTimeout(resolve, RETRY_CONF.delayMs));
            }
        }
    }

    // --- POLLING FUNCTION WITH STRICT ID CHECK ---
    async function pollJobResult(jobId, typingId, initialId) {
        const token = localStorage.getItem('authToken');
        let attempts = 0;
        // Network failures are counted apart from `attempts`: an outage must
        // not consume the answer-waiting budget.
        let networkFailures = 0;
        let pollTimer = null;
        let onlineHandler = null;

        // Going offline is known the instant it happens; waiting for the
        // in-flight request to time out first would leave the user staring at
        // the typing dots with no explanation.
        const offlineHandler = () => {
            showConnectionNotice('<strong>Connection lost.</strong> Your answer is still being prepared — it will appear as soon as you are back online.');
        };
        window.addEventListener('offline', offlineHandler);

        // Resume the moment the network returns rather than waiting out the
        // remaining backoff. The job id is still valid: the server kept working.
        const waitForOnline = () => {
            if (onlineHandler) return;
            onlineHandler = () => {
                onlineHandler = null;
                clearTimeout(pollTimer);
                checkStatus();
            };
            window.addEventListener('online', onlineHandler, { once: true });
        };

        // Every terminal branch goes through here: leaving the timer or the
        // listeners behind would resume a finished job and render the answer
        // twice the next time the connection flaps.
        const endPolling = () => {
            clearTimeout(pollTimer);
            clearConnectionNotice();
            window.removeEventListener('offline', offlineHandler);
            if (onlineHandler) {
                window.removeEventListener('online', onlineHandler);
                onlineHandler = null;
            }
        };

        const checkStatus = async () => {
            try {
                attempts++;
                const response = await $.ajax({
                    url: fiaChatData.ajaxUrl,
                    type: 'POST',
                    data: {
                        action: 'fia_check_job_status',
                        nonce: fiaChatData.nonce,
                        jobId: jobId,
                        userToken: token
                    }
                });

                // The poll completed, so the connection is back: drop the
                // outage notice and forgive the failures that led to it.
                networkFailures = 0;
                clearConnectionNotice();

                if (response.success && response.data) {
                    const resData = response.data;
                    let finalResult = resData;

                    while (finalResult && finalResult.result && typeof finalResult.result === 'object') {
                        finalResult = finalResult.result;
                    }

                    // --- CHANGE 1: Improved failure detection ---
                    // Detects success: false at any nesting level (like in your screenshot)
                    const isFailed = (resData.success === false || finalResult.success === false);
                    const isDone = (resData.done === true || finalResult.done === true);

                    if (isDone || isFailed) {
                        const confirmedId = finalResult.conversationId || resData.conversationId || initialId;
                        const currentActiveId = localStorage.getItem('ai_chat_session_id');

                        // --- CHANGE 2: Handle failure or empty results ---
                        // This catches the "raw_result -> success: false" case from your screenshot
                        if (isFailed || (isDone && !finalResult.answer && !finalResult.summary && !finalResult.raw_result?.result?.answer)) {
                            $(`#${typingId}`).remove();
                            $('.welcome-section').remove();

                            $chatMessages.append(`
                            <div class="message-wrapper assistant">
                                <div class="message assistant" style="color:#d9534f; border:1px solid #d9534f; background:#fdf7f7;">
                                    The service encountered a server error (5xx) or returned an empty response. Please try again later.
                                </div>
                            </div>`);

                            endPolling();
                            enableChatInput();
                            scrollToBottom();
                            return; // STOP POLLING
                        }

                        // 2. Sync session and reload for New Chat or Context Switch
                        const isNewOrDifferent = !currentActiveId || currentActiveId === 'null' || String(confirmedId) !== String(currentActiveId);

                        if (confirmedId && isNewOrDifferent) {
                            $(`#${typingId}`).remove();
                            localStorage.setItem('ai_chat_session_id', confirmedId);
                            window.currentConversationId = confirmedId;

                            if (window.loadConversations) {
                                await window.loadConversations(false);
                            }

                            if (typeof openConversation === 'function') {
                                await openConversation(confirmedId);
                            }

                            endPolling();
                            enableChatInput();
                            scrollToBottom();
                            return;
                        }

                        // 3. Normal render if already in correct context
                        let actualAnswer = finalResult.answer || finalResult.summary;
                        if (!actualAnswer && finalResult.raw_result?.result) {
                            actualAnswer = finalResult.raw_result.result.answer;
                        }

                        if (actualAnswer) {
                            $('.welcome-section').remove();
                            $(`#${typingId}`).remove();
                            appendMessage(actualAnswer, 'assistant', finalResult.sources || [], finalResult.answerCreatedAt || finalResult.answer_created_at || null);
                            saveChatState();
                            scrollToBottom();

                            setTimeout(() => {
                                if (window.loadConversations) window.loadConversations();
                            }, 500);

                            endPolling();
                            enableChatInput();
                            return; // STOP POLLING
                        }
                    }
                }

                if (attempts < 60) {
                    pollTimer = setTimeout(checkStatus, 3000);
                } else {
                    // --- CHANGE 3: Handle Timeout ---
                    $(`#${typingId}`).remove();
                    $chatMessages.append(`
                    <div class="message-wrapper assistant">
                        <div class="message assistant" style="color:#d9534f; border:1px solid #d9534f; background:#fdf7f7;">
                            <strong>Timeout.</strong> The server is taking too long to respond.
                        </div>
                    </div>`);
                    endPolling();
                    enableChatInput();
                }
            } catch (error) {
                console.error("[AI-DEBUG] Polling error:", error);

                // This branch used to end here: indicator gone, input unlocked,
                // nothing on screen. The user was left with a question that had
                // no answer and no explanation — the bug this card describes.
                if (isNetworkFailure(error)) {
                    networkFailures++;

                    if (networkFailures <= MAX_NETWORK_FAILURES) {
                        // The answer is still being written on the server, so
                        // the typing indicator stays: this is a pause, not a
                        // failure. Keep polling, and jump the queue the moment
                        // the browser reports it is back online.
                        showConnectionNotice('<strong>Connection lost.</strong> Your answer is still being prepared — it will appear as soon as you are back online.');
                        waitForOnline();
                        pollTimer = setTimeout(checkStatus, 3000);
                        return;
                    }

                    $(`#${typingId}`).remove();
                    endPolling();
                    showRetryableError(
                        'Still offline. Your answer may already be waiting on the server — check your connection and try again.',
                        () => {
                            showTypingIndicator(typingId);
                            pollJobResult(jobId, typingId, initialId);
                        }
                    );
                    enableChatInput();
                    return;
                }

                $(`#${typingId}`).remove();
                endPolling();
                showRetryableError(
                    'Something went wrong while waiting for the answer.',
                    () => {
                        showTypingIndicator(typingId);
                        pollJobResult(jobId, typingId, initialId);
                    }
                );
                enableChatInput();
            }
        };

        checkStatus();
    }


// System Message error
    function appendSystemErrorMessage(message) {
        const time = getCurrentTime();
        const errorHtml = `
        <div class="message-wrapper assistant">
            <div class="message assistant system-error" style="background: #fff5f5; border: 1px solid #ffcccc; color: #c53030;">
                <div style="font-size: 13px; opacity: 0.9;">${message}</div>
            </div>
            <div class="message-time">${time}</div>
        </div>`;

        $(`#typing-indicator-wrapper`).remove();
        $chatMessages.append(errorHtml);
        scrollToBottom();
    }


// --- UNIFIED ERROR HANDLER ---
    // `onRetry`, when given, repeats the exact request that failed. Errors the
    // user cannot act on (expired session) deliberately do not get a button.
    function handleChatError(error, typingId, onRetry) {
        $(`#${typingId}`).remove();
        currentAjaxRequest = null;

        if (error.statusText === 'abort') return;

        if (error.status >= 500) {
            appendSystemErrorMessage("Something Went Wrong. Please Try Again Send Message");
            console.error("Something Went Wrong. Please Try Again Send Message");
        }

        else if (error.statusText === 'timeout' || error.status === 504) {
            appendSystemErrorMessage("Something Went Wrong. Please Try Again Send Message");
            console.error("Something Went Wrong. Please Try Again Send Message");
        }

        if (error.status === 401 || error.status === 403) {
            console.error("Auth error: session expired or invalid token.");
            localStorage.removeItem('authToken');
            clearChatSession();
            showAuthError();
        }
        else if (error.statusText === 'timeout_limit') {
            $chatMessages.append(`
            <div class="ai-chat-error-overlay">
                <div class="ai-chat-error-bubble">
                    The server is taking too long to respond. Please try again in a few moments.
                </div>
            </div>`);
            resetInputState();
        }
        else if (isNetworkFailure(error)) {
            // Reached only after every retry failed, so the message is honest
            // about what happened and the button is the way out.
            clearConnectionNotice();
            showRetryableError(
                "<strong>Connection lost.</strong> Your session is still active, but we couldn't reach the server, so your message was not sent.",
                onRetry
            );
            resetInputState();
        }
        else {
            $chatMessages.append(`
            <div class="ai-chat-error-overlay">
                <div class="ai-chat-error-bubble">
                    Connection error. Your session is still active, but we couldn't reach the server. Please try again.
                </div>
            </div>`);
            resetInputState();
        }
        enableChatInput();
        scrollToBottom();
    }

    function resetInputState() {
        if (localStorage.getItem('authToken')) {
            $input.prop('disabled', false).attr('placeholder', 'Write a message...');
            $sendBtn.prop('disabled', false).css('opacity', '1');
        }
    }

    function showAuthError() {
        const html = `
        <div class="ai-chat-error-overlay auth-error-container">
            <div class="ai-chat-error-bubble">
                <p>Your session has expired, log in again.</p>
                <a href="/login" class="ai-auth-redirect-btn">Log In</a>
            </div>
        </div>`;
        $chatMessages.append(html);
        scrollToBottom();
        $input.prop('disabled', true).attr('placeholder', 'Authentication required...');
        $sendBtn.prop('disabled', true).css('opacity', '0.5');
    }

    // --- APPEND MESSAGE ---
    function appendMessage(text, side, citations = [], createdAt = null) {
        const time = formatMessageTime(createdAt);
        const msgId = Date.now() + Math.floor(Math.random() * 1000);
        const breakStyle = 'style="word-break: break-word; white-space: pre-wrap;"';

        if (side === 'user') {
            const safeText = escapeHtml(text);
            $chatMessages.append(`<div class="message-wrapper user"><div class="message user" ${breakStyle}>${safeText}</div><div class="message-time">${time}</div></div>`);
        } else {
            let safeRawText = escapeHtml(text);

            // Finished links wait outside the text until the markdown below is
            // done. Left in place, the "_..._" rule paired the "_" of one URL
            // (collateral-opinion-eygpt_1) with the next "_" in the answer and
            // wrote <em> into the href, which broke the link (FIA-2628).
            const links = [];
            // A title may hold one level of "[...]": some library documents are
            // named like "JSCC_-_..._(February_26_2018_against_May_23_2017)[1]",
            // and the backend renumbers that "[1]" as a citation. With [^\]]+
            // the link stopped matching and showed as raw "[...](https://...)".
            // A bare "[n]" left in a title is that citation number; drop it.
            safeRawText = safeRawText.replace(/\[((?:[^\[\]]|\[[^\[\]]*\])+)\]\(((?:https?:\/\/|mailto:)[^\s)]+)\)/g, (match, title, url) => {
                const isMailto = url.toLowerCase().startsWith('mailto:');
                const attrs = isMailto ? '' : ' target="_blank" rel="noopener noreferrer"';
                title = title.replace(/\s*\[\d+\]/g, '').trim() || title;
                links.push(`<a href="${url}"${attrs} class="ai-content-link">${title}</a>`);
                return `\u0000${links.length - 1}\u0000`;
            });

            let formattedText = safeRawText.replace(/\[citation:[^\]]+\]/gi, '').trim();

            // The closing "Information current as of ..." line. Older answers also
            // say "This information is current as of ..." on the end of the last
            // paragraph, so match the wording loosely and start a new line for it.
            const dateLinePattern = /(?:(?:this|the)\s+)?information\s+(?:is\s+)?current\s+(?:as\s+)?of\b[^\n]*$/i;
            formattedText = formattedText.replace(dateLinePattern, (dateLine, offset) =>
                (offset > 0 && formattedText[offset - 1] !== '\n' ? '\n\n' : '') + dateLine);

            const lines = formattedText.split('\n');
            let isInsideTable = false;
            let isInsideQuote = false;
            let tableMarkup = '';
            let finalLines = [];

            lines.forEach((line) => {
                const trimmed = line.trim();
                if (trimmed.startsWith('|') && trimmed.endsWith('|')) {
                    if (isInsideQuote) { isInsideQuote = false; finalLines.push('</blockquote>'); }
                    if (!isInsideTable) {
                        isInsideTable = true;
                        tableMarkup = '<div class="table-responsive my-3"><table class="table table-bordered table-sm ai-chat-table">';
                    }
                    if (trimmed.includes('---')) return;
                    const cells = trimmed.split('|').filter((c, i, a) => i !== 0 && i !== a.length - 1);
                    const tag = tableMarkup.includes('<thead>') ? 'td' : 'th';
                    if (tag === 'th') tableMarkup += '<thead><tr>'; else tableMarkup += '<tr>';
                    cells.forEach(cell => tableMarkup += `<${tag}>${cell.trim()}</${tag}>`);
                    if (tag === 'th') tableMarkup += '</tr></thead><tbody>'; else tableMarkup += '</tr>';
                } else if (trimmed.startsWith('&gt;') || trimmed.startsWith('>')) {
                    if (isInsideTable) { isInsideTable = false; finalLines.push(tableMarkup + '</tbody></table></div>'); }
                    const content = trimmed.replace(/^(&gt;|>)/, '').trim();
                    if (!isInsideQuote) { isInsideQuote = true; finalLines.push(`<blockquote>${content}`); } else { finalLines.push(`<br>${content}`); }
                } else {
                    if (isInsideTable) { isInsideTable = false; tableMarkup += '</tbody></table></div>'; finalLines.push(tableMarkup); }
                    if (isInsideQuote) { isInsideQuote = false; finalLines.push('</blockquote>'); }
                    finalLines.push(line);
                }
            });
            if (isInsideTable) finalLines.push('</tbody></table></div>');
            if (isInsideQuote) finalLines.push('</blockquote>');

            formattedText = finalLines.join('\n')
                .replace(/^[-*]{3,}$/gm, '<hr>')
                .replace(/^######\s+(.*)/gm, '<h6>$1</h6>')
                .replace(/^#####\s+(.*)/gm, '<h5>$1</h5>')
                .replace(/^####\s+(.*)/gm, '<h4>$1</h4>')
                .replace(/^###\s+(.*)/gm, '<h3>$1</h3>')
                .replace(/^##\s+(.*)/gm, '<h2>$1</h2>')
                .replace(/^#\s+(.*)/gm, '<h1>$1</h1>')
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/\*([^*]+)\*/g, '<em>$1</em>')
                // Only a whole "_word_", as in markdown: an "_" inside a word
                // (FIA_NCCL_2024.pdf) stays an underscore.
                .replace(/(^|\W)_([^_\n]+)_(?!\w)/g, '$1<em>$2</em>')
                .replace(/^\d+\.\s+(.*)/gm, '<li>$1</li>')
                .replace(/^([-*•])\s*(.*)/gm, '<li>$2</li>');

            if (formattedText.includes('<li>') && !formattedText.includes('<ul>')) {
                formattedText = formattedText.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
            }

            const outputLines = formattedText.split(/\n+/);
            let lastTextLine = outputLines.length - 1;
            while (lastTextLine > 0 && !outputLines[lastTextLine].trim()) lastTextLine--;

            formattedText = outputLines.map((line, index) => {
                if (index === lastTextLine && line.trim().search(dateLinePattern) === 0) return `<p class="info-date-small">${line.trim()}</p>`;
                if (line.match(/^<(ul|li|h|div|hr|table|blockquote|br)/)) return line;
                return line.trim() ? `<p>${line}</p>` : '';
            }).join('');

            formattedText = formattedText.replace(/\[(\d+)\]([.,!?;])?/g, (match, n, punc) => {
                const num = parseInt(n);
                const punctuation = punc || '';
                if (citations[num - 1]) {
                    return `<span style="white-space: nowrap;"><a href="#source-${msgId}-${num}" class="citation-mark">${num}</a></span>${punctuation}`;
                }
                return match;
            });

            formattedText = formattedText.replace(/\u0000(\d+)\u0000/g, (match, n) => links[n]);

            let sourcesHtml = '';
            if (citations.length > 0) {
                const currentOrigin = window.location.origin;
                const baseDocUrl = `${currentOrigin}/view-document/`;
                const basePageUrl = `${currentOrigin}/`;
                // const baseDocUrl = "https://fiadocumen-83bdcf5baf-cgd5cce2bjerb0c6.z02.azurefd.net/view-document/";
                // const basePageUrl = "https://fiadocumen-83bdcf5baf-cgd5cce2bjerb0c6.z02.azurefd.net/";

                sourcesHtml = `
            <div class="sources-section">
                <div class="sources-title">Sources:</div>
                <div class="sources-list">
                    ${citations.map((c, i) => {
                    if (!c) return '';
                    const displayNum = i + 1;
                    const displayTitle = c.displayTitle || c.documentTitle || 'Untitled Document';

                    let finalUrl = '';

                    if (c.type === 'page') {
                        // Page sources have no document/version id. Link to the page
                        // itself when its URL is known; otherwise render with no link
                        // (never fall through to a broken /view-document/ link).
                        if (c.pageUrl) {
                            finalUrl = /^https?:\/\//i.test(c.pageUrl)
                                ? c.pageUrl
                                : `${basePageUrl}${c.pageUrl.replace(/^\//, '')}`;
                        } else {
                            finalUrl = '';
                        }
                    } else if (c.documentId) {
                        finalUrl = `${baseDocUrl}?doc=${c.documentId}&ver=${c.versionId || ''}`;
                    } else {
                        finalUrl = '';
                    }

                    const sourceInner = `
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
                                <span>[${displayNum}] ${escapeHtml(displayTitle)}</span>`;

                    // No usable URL -> render as plain (non-clickable) source instead
                    // of an anchor pointing nowhere.
                    if (!finalUrl) {
                        return `
                            <span id="source-${msgId}-${displayNum}" class="source-link source-link-disabled">${sourceInner}
                            </span>`;
                    }

                    return `
                            <a href="${finalUrl}" id="source-${msgId}-${displayNum}" class="source-link" target="_blank">${sourceInner}
                            </a>`;
                }).join('')}
                </div>
            </div>`;
            }

            $chatMessages.append(`<div class="message-container assistant">${fiaLogoSvg}<div class="assistant-content"><div class="assistant-name">Assistant</div><div class="message assistant"><div class="text-content" ${breakStyle}>${formattedText}</div>${sourcesHtml}</div><div class="message-time">${time}</div></div></div>`);
        }
        scrollToBottom();
    }


    function showTypingIndicator(id) {
        $chatMessages.append(`<div class="message-container assistant" id="${id}">${fiaLogoSvg}<div class="assistant-content"><div class="assistant-name">Assistant</div><div class="typing-dots"><span></span><span></span><span></span></div><div class="message-time">${getCurrentTime()}</div></div></div>`);
        scrollToBottom();
    }

    // --- EVENTS ---
    $('#ai-chat-launcher').on('click', () => toggleSidebar(true));
    $('#ai-close-btn').on('click', () => toggleSidebar(false));
    $('.ai-expand-btn').on('click', (e) => {
        e.preventDefault();
        setFullScreen(!$chatWindow.hasClass('full-screen'));
    });
    $('#ai-new-chat-btn').on('click', () => {
        clearChatSession();
        saveChatState();
    });

    $(document).on('click', '.conv-item', function() {
        const id = $(this).data('id');
        $('.conv-item').removeClass('active');
        $(this).addClass('active');
        openConversation(id);
    });

    $sendBtn.on('click', sendMessage);
    $input.on('keydown', function(e) { if (e.which === 13 && !e.shiftKey) { e.preventDefault(); sendMessage(); } });

    $input.on('input', function() {
        this.style.height = '45px';
        const scrollH = this.scrollHeight;
        this.style.height = (scrollH > 150 ? 150 : scrollH) + 'px';
    });


    $('#ai-conversations-list').on('scroll', function() {
        const $this = $(this);
        const scrollTop = $this.scrollTop();
        const containerHeight = $this.innerHeight();
        const contentHeight = $this[0].scrollHeight;

        if (scrollTop + containerHeight >= contentHeight - 50) {
            if (!isLoadingHistory && hasMoreHistory) {
                console.log("Loading more history... Skip:", historySkip);
                loadConversations(true);
            }
        }
    });

    // Final Init
    if (localStorage.getItem('ai_chat_is_open') === 'true') toggleSidebar(true);

    $(document).on('click', '#ai-new-chat-top-btn', function(e) {
        e.preventDefault();
        clearChatSession();
        saveChatState();

        $('.conv-item').removeClass('active');
        console.log("New chat started via header button");
    });

    // Sidebar Hide on mobile
    document.addEventListener('click', function (event) {
        const sidebar = document.getElementById('ai-chat-sidebar');
        const windowWrapper = document.getElementById('ai-chat-window');
        if (!sidebar || !windowWrapper) return;
        const isMobile = window.innerWidth < 1024;

        if (isMobile && windowWrapper.classList.contains('history-open')) {

            const isClickInsideSidebar = sidebar.contains(event.target);

            const isClickOnToggleBtn = event.target.closest('#ai-new-chat-top-btn') ||
                event.target.closest('#ai-history-btn') ||
                event.target.closest('.conv-menu-btn');

            if (!isClickInsideSidebar && !isClickOnToggleBtn) {
                windowWrapper.classList.remove('history-open');
                $('.chevron').removeClass('rotated');

                window.dispatchEvent(new Event('resize'));
            }
        }
    });

});

function renderSingleServiceReport(serviceName, data) {
    if (!Array.isArray(data)) return;

    const VIEW_URL = `${window.location.origin}/view-document/`;

    const FILE_ICONS = {
        'word':  'https://cdn-icons-png.flaticon.com/512/888/888883.png',
        'pdf':   'https://cdn-icons-png.flaticon.com/512/337/337946.png',
        'excel': 'https://cdn-icons-png.flaticon.com/512/888/888850.png',
        'other': 'https://cdn-icons-png.flaticon.com/512/1091/1091916.png'
    };

    function buildLinksHtml(links) {
        if (!links || !links.length) return '';
        return `<div class="fsr-links">
            ${links.map(link => {
            const href = `${VIEW_URL}?doc=${link.documentId}&ver=${link.versionId || ''}`;
            const icon = FILE_ICONS[link.icon] || FILE_ICONS['other'];
            return `<a href="${href}" target="_blank" class="fsr-link-btn">
                    <img src="${icon}" width="13" height="13" alt=""> ${link.name || 'Document'}
                </a>`;
        }).join('')}
        </div>`;
    }

    // ─── Helpers ─────────────────────────────────────────────────────────────

    function wrapFootnotes(html) {
        return html.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, text) => {
            if (tag) return tag;
            return text.replace(/(?<=[a-zA-Z])\.?(\d+)(?=[\s,.<)%]|$)/g, '<sup>$1</sup>');
        });
    }

    function convertInlineMarkdown(text) {
        return text
            .replace(/\*\*\*\s*(.+?)\s*\*\*\*/g,                    '<strong><em>$1</em></strong>')
            .replace(/\*\*\s*(.+?)\s*\*\*/g,                         '<strong>$1</strong>')
            .replace(/(?<!\*)\*(?!\s)(.+?)(?<!\s)\*(?!\*)/g,        '<em>$1</em>')
            .replace(/__([^_\n]+)__/g,                               '<u>$1</u>')
            .replace(/_([^_\n]+)_/g,                                 '<em>$1</em>')
            .replace(/\^(\d+)/g,                                     '<sup>$1</sup>');
    }

    function applyMarkdownToHtml(html) {
        return html.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, text) => {
            if (tag) return tag;
            return convertInlineMarkdown(text);
        });
    }

    // ── Fix: post-process answerHtml from PDF/Word extraction ────────────────
    // Fixes two bugs that appear across multiple services (B3, LME, etc.):
    //  1. Bold/italic tag boundaries touching adjacent text without space
    //     e.g. "text<strong>bold</strong>text" → "text <strong>bold</strong> text"
    //  2. <font> colour/size/face overrides left over from PDF conversion → strip tag, keep text
    function postProcessAnswerHtml(html) {
        if (!html) return html;

        // Fix 1: inject space at </tag>word and word<tag> boundaries
        // Covers: strong, em, b, i, u, sup, sub
        html = html.replace(/<\/(strong|em|b|i|u|sup|sub)>([a-zA-Z0-9À-ɏ,;:!?])/g,
            '</$1> $2');
        html = html.replace(/([a-zA-Z0-9À-ɏ,;])<(strong|em|b|i|u|sup|sub)(\s|>)/g,
            '$1 <$2$3');

        // Fix 2: strip <font> tags (colour/size/face from PDF/Word exports), keep text
        html = html.replace(/<font[^>]*>/gi, '');
        html = html.replace(/<\/font>/gi, '');

        // Fix 3: collapse empty <span> wrappers with only empty attributes
        html = html.replace(/<span(\s+[a-z-]+=(?:""|''))+\s*>/gi, '<span>');
        html = html.replace(/<span>\s*<\/span>/gi, '');

        // Fix 4: convert <p>*+ Note: text</p> into styled note lines
        // PDF extraction uses 1–12 asterisks as footnote reference markers before "Note:"
        // These are NOT markdown bold — they are footnote anchors like * ** *** ****
        // Convert them to: <p class="fsr-note"><sup>*+</sup> Note: text</p>
        // Fix 4: convert <p>*+ Note: text</p> into styled note lines
        html = html.replace(/<p>(\*{1,15})\s+Note:/g, (match, stars) => {
            return `<p class="fsr-note"><sup>${stars}</sup>\u00a0Note:`;
        });

        // Fix 5: wrap inline asterisk footnote anchors mid-sentence
        // e.g. "...its limit.***</p>" → "...its limit.<sup>***</sup></p>"
        html = html.replace(/(?<!<sup>)(\*{1,15})(?=\s*<\/p>|\s*<br)/g, '<sup>$1</sup>');

        // Fix 6: strip □/❑/□□ box-characters

        // Fix 5: strip □/❑/□□ box-characters from the start of <li> and <p> content.
        // The B3 and some other CCP PDFs use □ (U+25A1) as list-item markers inside
        // their rule documents. The PDF extractor preserves them literally, producing
        // <li>□□), periodically assessing...</li> or <li>□□with regards to...</li>.
        // We strip ALL leading box-chars (and their trailing punctuation like ) or ,)
        // from the start of <li>/<p> tag content so only the actual text remains.
        const BOX_CHARS = /^[\u25A0-\u25FF\u2610-\u2612\u25AA\u25AB\uFFFD]+[)\s,]*/;
        html = html.replace(/(<li>|<p>)([\u25A0-\u25FF\u2610-\u2612\uFFFD]+[)\s,]*)/g,
            '$1');

        return html;
    }

    function formatAnswer(item) {
        let rawSource = (item.answerHtml && item.answerHtml.trim()) ? item.answerHtml : (item.answer || '');
        if (!rawSource.trim()) return '';

        if (item.answerHtml && item.answerHtml.trim()) {
            // postProcessAnswerHtml fixes bold-merge & <font> tag overrides from PDF extraction
            return wrapFootnotes(postProcessAnswerHtml(applyMarkdownToHtml(rawSource)));
        }

        let cleanText = rawSource
            .replace(/<p>/gi,       '')
            .replace(/<\/p>/gi,     '\n')
            .replace(/<ul>/gi,      '')
            .replace(/<\/ul>/gi,    '\n')
            .replace(/<ol>/gi,      '')
            .replace(/<\/ol>/gi,    '\n')
            .replace(/<li>/gi,      '- ')
            .replace(/<\/li>/gi,    '\n')
            .replace(/<br\s*\/?>/gi,'\n');

        cleanText = cleanText.replace(/[^\S\n]*[❑□▪▸►◆◇●○✓✔✗✘][^\S\n]*/g, '\n- ');

        cleanText = cleanText.replace(/\^(\d+)/g, '<sup>$1</sup>');

        const rawLines = cleanText.split(/\r\n|\r|\n/);

        const lines = [];
        for (let i = 0; i < rawLines.length; i++) {
            const t = rawLines[i].trim();

            if (t === '-') {
                let j = i + 1;
                while (j < rawLines.length && !rawLines[j].trim()) j++;

                if (j < rawLines.length) {
                    lines.push('- ' + rawLines[j].trim());
                    i = j;
                    continue;
                }
            }
            lines.push(rawLines[i]);
        }

        let result  = '';
        let ulBuffer = [];
        let olBuffer = [];
        let paragraphBuffer = [];

        function flushUl() {
            if (!ulBuffer.length) return;
            result += '<ul class="fsr-ul">' + ulBuffer.map(l => `<li>${l}</li>`).join('') + '</ul>';
            ulBuffer = [];
        }
        function flushOl() {
            if (!olBuffer.length) return;
            result += '<ol class="fsr-ol">' + olBuffer.map(l => `<li>${l}</li>`).join('') + '</ol>';
            olBuffer = [];
        }
        function flushParagraph() {
            if (!paragraphBuffer.length) return;
            result += `<p class="fsr-p">${paragraphBuffer.join('<br>')}</p>`;
            paragraphBuffer = [];
        }

        lines.forEach(line => {
            let trimmed = line.trim();


            if (!trimmed) {
                flushUl();
                flushOl();
                flushParagraph();
                return;
            }

            trimmed = trimmed
                .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
                .replace(/\*\*(.+?)\*\*/g,     '<strong>$1</strong>')
                .replace(/__(.+?)__/g,         '<strong>$1</strong>')
                .replace(/(?<!\*)\*(?!\s)(.+?)(?<!\s)\*(?!\*)/g, '<em>$1</em>')
                .replace(/(?<!_)_(?!\s)(.+?)(?<!\s)_(?!_)/g,     '<em>$1</em>');

            const ulMatch = trimmed.match(/^[-•*□❑▪▸►◆◇●○✓✔✗✘]\s*(.+)/i);
            const olMatch = trimmed.match(/^(\d+)\.\s*(.+)/i);

            if (ulMatch) {
                flushOl();
                flushParagraph();
                ulBuffer.push(ulMatch[1]);
            } else if (olMatch) {
                flushUl();
                flushParagraph();
                olBuffer.push(olMatch[2]);
            } else {
                flushUl();
                flushOl();

                if (trimmed.endsWith(':') && trimmed.replace(/<[^>]+>/g, '').length <= 90) {
                    flushParagraph();
                    result += `<h4 class="fsr-sub-label">${trimmed}</h4>`;
                } else if (trimmed.startsWith('Yes.') || trimmed.startsWith('No.')) {
                    flushParagraph();
                    const word = trimmed.substring(0, trimmed.indexOf('.'));
                    const rest = trimmed.substring(trimmed.indexOf('.') + 1);
                    result += `<p class="fsr-p"><span class="fsr-badge">${word}</span>${rest}</p>`;
                } else {
                    paragraphBuffer.push(trimmed);
                }
            }
        });

        flushUl();
        flushOl();
        flushParagraph();

        result = wrapFootnotes(result);
        return result;
    }

    let tableRows = '';

    data.forEach(item => {
        if (item.type === 'heading') {
            const isTop = item.level === 0;
            tableRows += `
            <tr class="fsr-heading-row ${isTop ? 'fsr-heading-top' : 'fsr-heading-sub'}">
                <td colspan="2">${item.text}</td>
            </tr>`;

        } else if (item.type === 'answer') {
            const answerHtml = formatAnswer(item);
            const linksHtml  = buildLinksHtml(item.links);

            if (!answerHtml && !linksHtml) return;

            tableRows += `
            <tr class="fsr-answer-row">
                <td class="fsr-td-q">${item.question}</td>
                <td class="fsr-td-a">
                    <div class="fsr-answer">${answerHtml}</div>
                    ${linksHtml}
                </td>
            </tr>`;
        }
    });

    // ─── Assemble final HTML ──────────────────────────────────────────────────

    // Scoped style: ensures <ul>/<ol> inside the answer column stay within the cell.
    // list-style-position:outside (browser default) + no padding-left = bullets overflow left.
    const fsrStyle = `<style>
        #fia-single-report .fsr-td-a .fsr-ul,
        #fia-single-report .fsr-td-a .fsr-ol,
        #fia-single-report .fsr-td-a ul,
        #fia-single-report .fsr-td-a ol  { padding-left: 1.5em; margin: 0.2em 0; }
        #fia-single-report .fsr-td-a li  { word-break: break-word; }
        #fia-single-report .fsr-td-a p   { margin-bottom: 0.35em; word-break: break-word; }
        #fia-single-report .fsr-note      { color: #555; font-size: 0.88em; margin-top: 0.15em; margin-bottom: 0.15em; }
        #fia-single-report .fsr-note sup  { font-size: 0.8em; color: #888; letter-spacing: -0.5px; }
    </style>`;

    const html = `${fsrStyle}
    <div class="fsr-wrap" id="fia-single-report">
        <div class="fsr-header">
            <h2 class="fsr-title">Service Report: ${serviceName}</h2>
            <button class="fsr-close" onclick="$('#fia-single-report').remove()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>
        <div class="fsr-table-wrap">
            <table class="fsr-table">
                <colgroup>
                    <col style="width:32%">
                    <col style="width:68%">
                </colgroup>
                <tbody>${tableRows || '<tr><td colspan="2" class="fsr-empty">No data available.</td></tr>'}</tbody>
            </table>
        </div>
    </div>`;

    $('.report-container, #fia-single-report').remove();
    $(CONFIG.CONTAINERS.ACCORDION).after(html);
    $('html, body').animate({ scrollTop: $('#fia-single-report').offset().top - 80 }, 500);
}

// AI page logic integration
jQuery(document).ready(function($) {

    const $userInput = $('#ai-user-input');

    function hideWelcomeContent() {
        const welcomeSection = document.querySelector('.welcome-section');
        if (welcomeSection) {
            welcomeSection.remove();
        }
    }

    let currentPageContextId = null;
    let lastPageData = null;

    // 1. Reset logic
    $(document).on('click', '#ai-new-chat-btn', function() {
        currentPageContextId = null;
        lastPageData = null;
        window.currentConversationId = null;
        $('#ai-summarize-btn-fixed').fadeIn(200);
        $('#ai-page-context-status').fadeOut();
        $('#fia-use-context-toggle').prop('checked', false).trigger('change');

        $userInput.attr('placeholder', 'Write a message...');
    });

    // 2. Click on "Summarize page" button
    $(document).on('click', '.fia-trigger-page-summary', function(e) {
        e.preventDefault();
        hideWelcomeContent();
        const $checkbox = $('#fia-use-context-toggle');
        $checkbox.prop('checked', true).trigger('change');
        handlePageSummarization($(this));
    });

    // 3. Status bar logic
    $(document).on('click', '#ai-page-context-status', function(e) {
        if ($(e.target).closest('.fia-switch').length > 0) return;
        const $checkbox = $('#fia-use-context-toggle');
        const newState = !$checkbox.prop('checked');
        $checkbox.prop('checked', newState).trigger('change');
    });

    $(document).on('change', '#fia-use-context-toggle', function() {
        const isChecked = $(this).is(':checked');
        $('#ai-page-context-status').css('background', isChecked ? '#f0f7ff' : '#f8fbff');
    });

    /**
     * MAIN FUNCTION: POST /api/ai/chat/summarizePageAsync
     */
    async function handlePageSummarization($el) {
        if ($el.hasClass('working')) return;

        $('#ai-summarize-btn-fixed').fadeOut(200);

        $userInput.val('').attr('placeholder', 'Wait please...');

        const token = localStorage.getItem('authToken');

        // Signed out, the header below would go out as the literal "Bearer null":
        // a malformed credential rather than an absent one, which the API has to
        // reject. Say it here instead of spending a round trip to be refused.
        //
        // The notice is written inline on purpose: appendMessage() belongs to a
        // different jQuery.ready block, so calling it from here throws
        // ReferenceError and leaves the chat stuck on "Wait please...".
        if (!token) {
            $('#ai-chat-messages').append(
                '<div class="message-wrapper assistant">' +
                '<div class="message assistant">Please sign in to summarise this page.</div>' +
                '</div>'
            );
            unlockInterface();
            return;
        }

        const pageTitle = $('.hero-title').text().trim() || document.title;
        const pageContent = getCleanPageContent();

        lastPageData = {
            title: pageTitle,
            content: pageContent,
            url: window.location.href
        };

        // UI State
        $('#ai-active-page-title').text(pageTitle);
        $('#ai-page-context-status').fadeIn().css('display', 'flex').addClass('working');
        $('.fia-trigger-page-summary').addClass('working').css('opacity', '0.5');
        $('#ai-user-input, #ai-send-btn').prop('disabled', true);

        try {
            const response = await $.ajax({
                url: '/api/ai/chat/summarizePageAsync',
                type: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    pageData: lastPageData,
                    conversationId: window.currentConversationId
                })
            });

            const jobId = response.jobId || response.result?.jobId;
            if (jobId) pollJobResult(jobId);

        } catch (err) {
            console.error("Direct Azure Error:", err);
            unlockInterface();
        }
    }

    // Text of the page sent to the AI for "Summarize this page" and for the
    // questions asked in page context afterwards.
    //
    // The Legal Documents List template has no <main>, so the old 'main'
    // fallback matched nothing there: the jurisdiction headings, the text above
    // each accordion and the content_page block never reached the AI. The
    // selected blocks also nest (.accordion-content sits inside
    // .documents-container), so the same text went out twice, and every link
    // carried its full URL - 70% of the payload on /netting/. Under the old
    // 15 000-character cap that left the AI the first two regions of a
    // seven-region page, and it made up the rest.
    //
    // Now: only the outermost content blocks, in page order; headings and list
    // items on their own lines so a document stays attached to its
    // jurisdiction. The limit stays well under the backend's 100 kB JSON body
    // limit.
    //
    // Links go out as "text (URL)" whenever the page still fits that way, so the
    // AI can hand the user a working link: without the URL a WORD / PDF link
    // reached it as the bare word and came back as "[WORD]" with nothing to
    // click. The three largest document-list pages (Netting, Collateral, IAS 32:
    // 73 000-103 000 characters with URLs, 21 000-25 000 without) do not fit,
    // and for them the text-only version is sent instead - every document
    // named, none linked - rather than a version cut off part-way down the page.
    const PAGE_CONTENT_LIMIT = 40000;

    // A page still over the limit without its URLs - the CCP Risk Review report
    // pages run to 70 000-540 000 characters - is cut, and now says so. A silent
    // cut gave the AI no way to tell that the page went on, so it answered
    // questions about the missing part as if it had read it.
    const PAGE_TRUNCATION_NOTE = '\n\n[Page content truncated here: the rest of this page was not included.]';

    function getCleanPageContent() {
        const withLinks = buildPageContent(true);

        if (withLinks.length <= PAGE_CONTENT_LIMIT) {
            return withLinks;
        }

        const textOnly = buildPageContent(false);

        if (textOnly.length <= PAGE_CONTENT_LIMIT) {
            return textOnly;
        }

        return textOnly.substring(0, PAGE_CONTENT_LIMIT - PAGE_TRUNCATION_NOTE.length) + PAGE_TRUNCATION_NOTE;
    }

    function buildPageContent(includeLinkUrls) {
        const selectors = [
            '.hero-section',
            '.legal-content',
            '.documents-container',
            '.jurisdictional-section',
            '.content-section',
            '.contact-section',
            '.accordion-content',
            '.country-card',
            'main'
        ];

        // Document order puts an ancestor before its descendants, so skipping
        // anything inside an already-taken block leaves only the outermost ones.
        const blocks = [];
        document.querySelectorAll(selectors.join(',')).forEach(el => {
            if (!blocks.some(block => block.contains(el))) {
                blocks.push(el);
            }
        });

        return blocks.map(block => {
            const copy = block.cloneNode(true);

            // Controls, not content. .hero-jurisdictions is the filter checkbox
            // list, which only repeats the jurisdiction headings.
            copy.querySelectorAll('script, style, svg, input, button, .hero-jurisdictions, .btn-contact, .docs-controls')
                .forEach(node => node.remove());

            // Absolute URLs, so a link the AI repeats works wherever the chat
            // renders it. In-page anchors, mail and phone links carry nothing
            // the user could open from the chat, so they stay as text.
            if (includeLinkUrls) {
                copy.querySelectorAll('a[href]').forEach(link => {
                    const label = link.textContent.replace(/\s+/g, ' ').trim();
                    const href = link.getAttribute('href') || '';

                    if (!label || /^(#|javascript:|mailto:|tel:)/i.test(href)) {
                        return;
                    }

                    try {
                        link.textContent = `${label} (${new URL(href, window.location.origin).href})`;
                    } catch (e) {
                        // An unparsable href stays as its text.
                    }
                });
            }

            // Flatten the heading first: the template's own line breaks inside
            // it would otherwise split the marker from the heading text.
            copy.querySelectorAll('h1, h2, h3, h4, h5, .legal-card-header').forEach(heading => {
                heading.textContent = '\n### ' + heading.textContent.replace(/\s+/g, ' ').trim() + '\n';
            });
            copy.querySelectorAll('li, p, tr, .doc-card').forEach(node => node.prepend('\n'));

            return copy.textContent
                .split('\n')
                .map(line => line.replace(/\s+/g, ' ').trim())
                .filter(Boolean)
                .join('\n');
        }).filter(Boolean).join('\n\n');
    }

    const unlockInterface = () => {
        $userInput.attr('placeholder', 'Write a message...');

        $('.working').removeClass('working').css('opacity', '1');
        $('#ai-page-context-status').removeClass('working');
        $('#ai-user-input').prop('disabled', false).focus();
        $('#ai-send-btn').prop('disabled', false);
        $('.ai-typing-indicator').remove();
    };

    // 4. Polling Job Result
    async function pollJobResult(jobId) {
        const token = localStorage.getItem('authToken');
        const tempId = 'msg-' + Date.now();
        const safetyUnlock = setTimeout(() => unlockInterface(), 60000);

        if (typeof showTypingIndicator === 'function') {
            showTypingIndicator(tempId);
        }

        const checkStatus = async () => {
            try {
                const response = await $.ajax({
                    url: fiaChatData.ajaxUrl,
                    type: 'POST',
                    data: {
                        action: 'fia_check_job_status',
                        nonce: fiaChatData.nonce,
                        jobId: jobId,
                        userToken: token
                    }
                });

                if (response.success) {
                    const target = response.data;

                    if (target.done && target.answer) {
                        clearTimeout(safetyUnlock);
                        $(`#${tempId}`).remove();
                        $('.welcome-card, .welcome-section').remove();

                        if (target.conversationId) {
                            window.currentConversationId = target.conversationId;
                            localStorage.setItem('ai_chat_session_id', target.conversationId);
                        }

                        const contextId = target.pageContextSessionId || target.pageContextId || target.sessionId;
                        if (contextId) {
                            window.currentPageContextId = contextId;
                            localStorage.setItem('last_page_context_id', contextId);
                            console.log("Context saved:", contextId);
                        }

                        if (typeof appendMessage === 'function') {
                            appendMessage(target.answer, 'assistant', target.sources || [], target.answerCreatedAt || target.answer_created_at || null);
                            const $msgContainer = $('#ai-chat-messages');
                            $msgContainer.animate({ scrollTop: $msgContainer.prop("scrollHeight") }, 300);
                        }

                        if (typeof window.loadConversations === 'function') {
                            $('#ai-conversations-list').empty().html('<div class="p-3 text-center opacity-50">Syncing...</div>');
                            setTimeout(async () => {
                                await window.loadConversations();
                                const $targetChat = $(`.conv-item[data-id="${window.currentConversationId}"]`);
                                if ($targetChat.length) {
                                    $('.conv-item').removeClass('active');
                                    $targetChat.addClass('active');
                                    $targetChat.trigger('click');
                                    $targetChat[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                }
                                if (typeof openConversation === 'function') {
                                    openConversation(window.currentConversationId);
                                }
                            }, 1500);
                        }

                        if (typeof saveChatState === 'function') saveChatState();
                        unlockInterface();
                        return;
                    }

                    if (target.done && !target.answer) {
                        $(`#${tempId}`).remove();
                        unlockInterface();
                        return;
                    }
                }

                setTimeout(checkStatus, 3000);

            } catch (error) {
                console.error("Polling error:", error);
                clearTimeout(safetyUnlock);
                $(`#${tempId}`).remove();
                unlockInterface();
            }
        };
        checkStatus();
    }

    /**
     * 5. Continue chat: Pass pageContextSessionId
     */
    async function continueConversationAsync(userMessage, conversationId) {
        const token = localStorage.getItem('authToken');
        const $toggle = $('#fia-use-context-toggle');
        window.currentConversationId = conversationId;

        $userInput.val('').attr('placeholder', 'Wait please...');
        $('#ai-user-input, #ai-send-btn').prop('disabled', true);

        let payload = {
            action: 'fia_continue_conversation',
            nonce: fiaChatData.nonce,
            userToken: token,
            message: userMessage,
            conversationId: conversationId
        };

        if ($toggle.is(':checked') && currentPageContextId) {
            payload.pageContextSessionId = currentPageContextId;
        }

        try {
            const response = await $.ajax({
                url: fiaChatData.ajaxUrl,
                type: 'POST',
                data: payload
            });

            if (response.error && response.error.code === "PAGE_CONTEXT_SESSION_DOES_NOT_EXIST") {
                return recoverSessionAndRetry(userMessage, conversationId);
            }

            const jobId = response.result?.jobId || response.data?.jobId;
            if (jobId) pollJobResult(jobId);
        } catch (err) {
            console.error("Continue conversation error:", err);
            unlockInterface();
        }
    }

    async function recoverSessionAndRetry(userMessage, conversationId) {
        const token = localStorage.getItem('authToken');
        let retryPayload = {
            action: 'fia_continue_conversation',
            nonce: fiaChatData.nonce,
            userToken: token,
            message: userMessage,
            conversationId: conversationId,
            pageData: lastPageData
        };

        try {
            const response = await $.ajax({
                url: fiaChatData.ajaxUrl,
                type: 'POST',
                data: retryPayload
            });
            const jobId = response.result?.jobId || response.data?.jobId;
            if (jobId) pollJobResult(jobId);
        } catch (err) {
            console.error("Recovery retry failed:", err);
            unlockInterface();
        }
    }
});


// Authorization logic

// 1. INSTANT CHECK (Executes before everything else)
(function() {
    const token = localStorage.getItem('authToken');
    if (token && window.location.pathname.includes('/login')) {
        window.location.href = '/user-profile';
    }
})();
const loginUser = async (event) => {
    event.preventDefault();

    const form = event.target;
    const emailInput = form.querySelector('#email');
    const password = form.querySelector('#password').value;
    const rememberCheckbox = form.querySelector('input[name="remember"]');
    const errorDiv = form.querySelector('#error-message');
    const submitBtn = form.querySelector('#submit-btn');

    const email = emailInput.value;

    // Clear previous errors
    if (errorDiv) {
        errorDiv.style.display = 'none';
        errorDiv.innerText = '';
    }

    // Disable button and show loading state
    submitBtn.disabled = true;
    const originalBtnText = submitBtn.innerText;
    submitBtn.innerText = 'Wait please...';

    try {
        const response = await fetch('/api/ai/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password })
        });

        const result = await response.json();

        if (response.ok && result.token) { // Status 200 and token exists
            // Logic for Remember Me
            if (rememberCheckbox && rememberCheckbox.checked) {
                localStorage.setItem('rememberedEmail', email);
            } else {
                localStorage.removeItem('rememberedEmail');
            }

            localStorage.setItem('authToken', result.token);
            window.location.href = '/user-profile';
        } else {
            // NEW: report the real status + server message (not just the generic text)
            window.fiaLogClientError('login', {
                message:    (result && result.error) || 'Non-OK login response',
                httpStatus: response.status,
                email:      email
            });
            // NO ALERT - only DOM error
            if (errorDiv) {
                // 429: too many failed attempts (F-04) - the server says how long
                // to wait and points to registration / password reset.
                errorDiv.innerText = response.status === 429 && result && result.error
                    ? result.error
                    : 'Incorrect Login or Password';
                errorDiv.style.display = 'block';
            }
        }

    } catch (error) {
        // NEW: network/CORS failures show up here — previously invisible to the server
        window.fiaLogClientError('login', {
            message:   error && error.message ? error.message : 'Network/CORS failure',
            errorName: error && error.name ? error.name : 'TypeError',
            httpStatus: 0,
            email:     email
        });
        console.error('Authorization error:', error);
        if (errorDiv) {
            errorDiv.innerText = window.FIA_UNREACHABLE_MESSAGE;
            errorDiv.style.display = 'block';
        }
    } finally {
        submitBtn.disabled = false;
        submitBtn.innerText = originalBtnText;
    }
};

// Toggle password visibility
const initPasswordToggle = () => {
    const toggleBtn = document.querySelector('#togglePassword');
    const passwordInput = document.querySelector('#password');

    if (toggleBtn && passwordInput) {
        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const isPassword = passwordInput.type === 'password';
            passwordInput.type = isPassword ? 'text' : 'password';
            toggleBtn.style.opacity = isPassword ? '0.5' : '1';
        });
    }
};

// Check if email was remembered
const checkRememberedEmail = () => {
    const emailInput = document.querySelector('#email');
    const rememberCheckbox = document.querySelector('input[name="remember"]');
    const savedEmail = localStorage.getItem('rememberedEmail');

    if (savedEmail && emailInput) {
        emailInput.value = savedEmail;
        if (rememberCheckbox) {
            rememberCheckbox.checked = true;
        }
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const token = localStorage.getItem('authToken');
    const loginSection = document.querySelector('.login-section');

    // Show login form only if user is not authenticated
    if (!token && loginSection) {
        loginSection.style.setProperty('display', 'block', 'important');
    }

    const loginForm = document.querySelector('#your-login-form-id');
    if (loginForm) {
        loginForm.addEventListener('submit', loginUser);
    }

    initPasswordToggle();
    checkRememberedEmail();
});


// Shared: map a backend password-rejection `code` to a specific, user-facing
// message. The backend's `error` field is just a fallback string and must
// never be shown as-is when a stable `code` is present — `code` is the
// contract we key off. Used by both the Register and Reset Password flows
// below (they share this file/module scope).
const PASSWORD_ERROR_MESSAGES = {
    password_too_short:     'Password must be at least 8 characters long.',
    password_too_weak:      'Password is too weak — add numbers, uppercase letters, and symbols.',
    password_too_long:      'Password is too long.',
    password_banned:        'This password is too common. Please choose a different one.',
    password_is_invalid:    'Password contains invalid characters or your account details.',
    password_recently_used: 'You have already used this password before. Please choose a new one.',
};

// Returns a specific message when `code` is a known password_* code, the raw
// `error` fallback when `code` is missing or unrecognized (e.g. a future
// backend code, or an unrelated error like a bad OTP), or null if neither
// field is present.
function getPasswordErrorMessage(responseJSON) {
    if (!responseJSON) return null;
    if (responseJSON.code && PASSWORD_ERROR_MESSAGES[responseJSON.code]) {
        return PASSWORD_ERROR_MESSAGES[responseJSON.code];
    }
    return responseJSON.error || null;
}

// User Register (Microsoft Entra External ID - Native Auth, two-step flow)
jQuery(document).ready(function($) {
    const REGISTER_API_BASE = '/api/ai/register';

    // Holds the continuationToken returned by /start so /complete can use it.
    let regState = {
        continuationToken: null,
        email: '',
        password: ''
    };

    const $form          = $('#registration-form');
    const $stepCreds     = $('#reg-step-credentials');
    const $stepCode      = $('#reg-step-code');
    const $submitBtn     = $('#reg-submit-btn');
    const $verifyBtn     = $('#reg-verify-btn');
    const $backBtn       = $('#reg-back-btn');
    const $resendBtn     = $('#reg-resend-btn');
    const $errorMsg      = $('#reg-error-message');
    const $successMsg    = $('#reg-success-message');
    const $codeHint      = $('#reg-code-hint');

    function showErrorMessage(text) {
        $errorMsg.text(text).fadeIn();
        $('html, body').animate({ scrollTop: $errorMsg.offset().top - 100 }, 300);
    }
    function clearMessages() {
        $errorMsg.hide().text('');
        $successMsg.hide();
    }

    // ----- Client-side password validation -------------------------------
    // Entra (CIAM) rejects weak/banned passwords server-side. We can't mirror
    // Microsoft's full banned-word dictionary, but we can catch the common
    // cases up front so the user gets instant feedback instead of waiting for
    // an email round-trip only to be rejected at the final step.
    const COMMON_BANNED_WORDS = [
        'password', 'passw0rd', 'welcome', 'qwerty', 'letmein', 'admin',
        'fia', 'documentation', 'login', 'changeme', 'iloveyou',
        'abc123', '111111', '123123', 'monkey', 'dragon', 'azerty'
    ];

    // Returns an error string if the password is invalid, or null if it's OK.
    function validatePassword(password, email) {
        if (!password || password.length < 8) {
            return 'Password must be at least 8 characters long.';
        }
        if (password.length > 256) {
            return 'Password is too long (max 256 characters).';
        }

        // Require a mix so trivial passwords are rejected before hitting Entra.
        let classes = 0;
        if (/[a-z]/.test(password)) classes++;
        if (/[A-Z]/.test(password)) classes++;
        if (/[0-9]/.test(password)) classes++;
        if (/[^A-Za-z0-9]/.test(password)) classes++;
        if (classes < 3) {
            return 'Password must include at least 3 of: lowercase, uppercase, numbers, symbols.';
        }

        if (/^\s|\s$/.test(password)) {
            return 'Password must not start or end with a space.';
        }

        const lower = password.toLowerCase();

        // Reject passwords built from the email local-part (e.g. "john" -> "John1234").
        if (email && email.indexOf('@') > -1) {
            const localPart = email.split('@')[0].toLowerCase().replace(/[^a-z0-9]/g, '');
            if (localPart.length >= 4 && lower.indexOf(localPart) > -1) {
                return 'Password must not contain your email name. Choose something unrelated.';
            }
            const domainName = email.split('@')[1] ? email.split('@')[1].split('.')[0].toLowerCase() : '';
            if (domainName.length >= 3 && lower.indexOf(domainName) > -1) {
                return 'Password must not contain your company name. Choose something unrelated.';
            }
        }

        // Reject obvious banned/common words (the same class Entra blocks).
        for (let i = 0; i < COMMON_BANNED_WORDS.length; i++) {
            if (lower.indexOf(COMMON_BANNED_WORDS[i]) > -1) {
                return 'This password is too common or contains a blocked word. Please choose a more unique passphrase.';
            }
        }

        // Reject season + year style passwords (Summer2025, Winter2026!, etc.).
        if (/(spring|summer|autumn|fall|winter)\s*\d{2,4}/i.test(password)) {
            return 'This password is too predictable (e.g. a season + year). Please choose a more unique passphrase.';
        }

        // Reject 4+ identical or simple sequential runs.
        if (/(.)\1{3,}/.test(password)) {
            return 'Password must not contain 4 or more repeated characters in a row.';
        }
        if (/(0123|1234|2345|3456|4567|5678|6789|abcd|qwer|asdf)/i.test(password)) {
            return 'Password must not contain a simple sequence like "1234" or "qwer".';
        }

        return null;
    }

    // Map a backend error (which carries an Entra suberror in `code`) to a
    // friendly, specific message. This is what turns the opaque 400 into
    // something the user can act on.
    function describeRegistrationError(responseJSON, httpStatus) {
        const code = responseJSON && responseJSON.code ? String(responseJSON.code) : '';

        if (code.indexOf('password') === 0) {
            return getPasswordErrorMessage(responseJSON);
        }
        if (httpStatus === 409) {
            return 'An account with this email already exists. Try logging in instead.';
        }
        if (httpStatus === 403) {
            return 'Registration is not available for this email domain. Please use your corporate email.';
        }
        if (responseJSON && responseJSON.error) {
            return responseJSON.error;
        }
        return null;
    }

    // Shared: call /start (used for both the initial submit and "Resend code").
    // Returns the jqXHR so callers can chain .done/.fail/.always.
    function requestStart(email, password) {
        return $.ajax({
            url: REGISTER_API_BASE + '/start',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ email: email, password: password })
        });
    }

    // STEP 1: submit email + password -> backend /start -> email is sent
    $form.on('submit', function(e) {
        e.preventDefault();
        clearMessages();

        const email           = $('#reg-email').val().trim();
        const password        = $('#reg-password').val();
        const confirmPassword = $('#reg-confirm-password').val();

        if (password !== confirmPassword) {
            showErrorMessage('Passwords do not match!');
            return;
        }

        // Validate BEFORE hitting the API so the user isn't sent an email and
        // then rejected at the final step.
        const pwError = validatePassword(password, email);
        if (pwError) {
            showErrorMessage(pwError);
            return;
        }

        $submitBtn.text('Sending code...').prop('disabled', true);

        requestStart(email, password).done(function(response) {
            regState.continuationToken = response.continuationToken;
            regState.email = email;
            regState.password = password;

            $codeHint.text('We emailed a verification code to ' + email + '. Enter it below.');
            $stepCreds.hide();
            $stepCode.show();
            $('#reg-code').focus();
        }).fail(function(err) {
            const unreachable = window.fiaIsUnreachable(err);
            // NEW: capture status + backend code so you can see WHY /start failed
            window.fiaLogClientError('register_start', {
                message:    unreachable
                    ? 'Request never reached the backend (network or CORS block)'
                    : (err.responseJSON && (err.responseJSON.error || err.responseJSON.code)) || 'start failed',
                httpStatus: err.status || 0,
                email:      email,
                detail:     err.statusText
            });
            let message = describeRegistrationError(err.responseJSON, err.status);
            if (!message) {
                message = unreachable
                    ? window.FIA_UNREACHABLE_MESSAGE
                    : 'Could not start registration. Please try again.';
            }
            showErrorMessage(message);
        }).always(function() {
            $submitBtn.text('Register').prop('disabled', false);
        });
    });

    // STEP 2: submit the code -> backend /complete -> account created + auto-login token
    $verifyBtn.on('click', function() {
        clearMessages();

        const code = $('#reg-code').val().trim();
        if (!code) {
            showErrorMessage('Please enter the verification code from your email.');
            return;
        }
        if (!regState.continuationToken) {
            showErrorMessage('Your session expired. Please start again.');
            return;
        }

        $verifyBtn.text('Verifying...').prop('disabled', true);

        $.ajax({
            url: REGISTER_API_BASE + '/complete',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                email: regState.email,
                password: regState.password,
                code: code,
                continuationToken: regState.continuationToken
            })
        }).done(function(response) {
            $verifyBtn.text('Success!').css('background', '#27ae60');
            $successMsg.fadeIn();

            // Auto-login: backend returns the same JWT as /login
            const token = response.token || response.access_token;
            if (token) {
                localStorage.setItem('authToken', token);
                setTimeout(function() { window.location.href = '/user-profile'; }, 1200);
            } else {
                setTimeout(function() { window.location.href = '/login/?registered=1'; }, 1500);
            }
        }).fail(function(err) {
            const unreachable = window.fiaIsUnreachable(err);
            // NEW: capture status + backend code so you can see WHY /complete failed
            window.fiaLogClientError('register_complete', {
                message:    unreachable
                    ? 'Request never reached the backend (network or CORS block)'
                    : (err.responseJSON && (err.responseJSON.error || err.responseJSON.code)) || 'complete failed',
                httpStatus: err.status || 0,
                email:      regState.email,
                detail:     err.statusText
            });
            let message = describeRegistrationError(err.responseJSON, err.status);
            if (!message) {
                message = unreachable
                    ? window.FIA_UNREACHABLE_MESSAGE
                    : 'Could not complete registration. Please check the code and try again.';
            }
            showErrorMessage(message);
            $verifyBtn.text('Confirm & create account').prop('disabled', false);

            // If the password was rejected at the final step, the code stays
            // valid but the password must change. Send the user back to step 1
            // with the password fields cleared so they can pick a new one
            // without re-entering the email.
            const code = err.responseJSON && err.responseJSON.code ? String(err.responseJSON.code) : '';
            const isPasswordProblem = code.indexOf('password') > -1;
            if (isPasswordProblem) {
                regState.continuationToken = null;
                $('#reg-password').val('');
                $('#reg-confirm-password').val('');
                $stepCode.hide();
                $stepCreds.show();
                $('#reg-email').val(regState.email);
                $('#reg-password').focus();
                $verifyBtn.text('Confirm & create account').css('background', '');
            }
        });
    });

    // Allow pressing Enter inside the code field to confirm
    $('#reg-code').on('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); $verifyBtn.click(); }
    });

    // RESEND CODE: re-trigger the OTP email without leaving step 2.
    // With the current backend this re-calls /start (which sends a fresh code
    // and returns a new continuationToken). A 30s cooldown prevents spamming.
    let resendCooldown = 0;
    let resendTimer = null;

    function startResendCooldown() {
        resendCooldown = 30;
        $resendBtn.prop('disabled', true);
        updateResendLabel();
        resendTimer = setInterval(function() {
            resendCooldown--;
            if (resendCooldown <= 0) {
                clearInterval(resendTimer);
                resendTimer = null;
                $resendBtn.prop('disabled', false);
                $resendBtn.text('Resend code');
            } else {
                updateResendLabel();
            }
        }, 1000);
    }
    function updateResendLabel() {
        $resendBtn.text('Resend code (' + resendCooldown + 's)');
    }

    $resendBtn.on('click', function() {
        if (resendCooldown > 0) return;
        clearMessages();

        if (!regState.email || !regState.password) {
            showErrorMessage('Your session expired. Please start again.');
            $stepCode.hide();
            $stepCreds.show();
            return;
        }

        $resendBtn.prop('disabled', true).text('Resending...');

        requestStart(regState.email, regState.password).done(function(response) {
            regState.continuationToken = response.continuationToken;
            $codeHint.text('We sent a new verification code to ' + regState.email + '. Enter it below.');
            $('#reg-code').val('').focus();
            startResendCooldown();
        }).fail(function(err) {
            let message = describeRegistrationError(err.responseJSON, err.status);
            if (!message) {
                message = 'Could not resend the code. Please try again.';
            }
            showErrorMessage(message);
            $resendBtn.prop('disabled', false).text('Resend code');
        });
    });

    // Go back to step 1
    $backBtn.on('click', function() {
        clearMessages();
        regState.continuationToken = null;
        if (resendTimer) { clearInterval(resendTimer); resendTimer = null; }
        resendCooldown = 0;
        $resendBtn.prop('disabled', false).text('Resend code');
        $stepCode.hide();
        $stepCreds.show();
        $verifyBtn.text('Confirm & create account').prop('disabled', false).css('background', '');
    });
});


// Reset Password (Microsoft Entra External ID - Native Auth, two-step flow)
jQuery(document).ready(function($) {
    const RESET_API_BASE = '/api/ai/resetPassword';

    let resetState = {
        continuationToken: null,
        email: ''
    };

    const $form        = $('#reset-password-form');
    const $stepEmail   = $('#reset-step-email');
    const $stepCode    = $('#reset-step-code');
    const $submitBtn   = $('#reset-submit-btn');
    const $confirmBtn  = $('#reset-confirm-btn');
    const $backBtn     = $('#reset-back-btn');
    const $errorMsg    = $('#reset-error-message');
    const $successMsg  = $('#reset-success-message');

    if (!$form.length) {
        return;
    }

    function showError(text) {
        $errorMsg.text(text).fadeIn();
    }
    function clearMessages() {
        $errorMsg.hide().text('');
        $successMsg.hide();
    }

    // STEP 1: submit email -> backend /start -> reset code emailed
    $form.on('submit', function(e) {
        e.preventDefault();
        clearMessages();

        const email = $('#reset-email').val().trim();
        if (!email) {
            showError('Please enter your email.');
            return;
        }

        $submitBtn.text('Sending...').prop('disabled', true);

        $.ajax({
            url: RESET_API_BASE + '/start',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ email: email })
        }).done(function(response) {
            // Generic response: we always move to step 2 so we don't reveal
            // whether the account exists. continuationToken may be null.
            resetState.continuationToken = response.continuationToken;
            resetState.email = email;

            $stepEmail.hide();
            $stepCode.show();
            $('#reset-code').focus();
        }).fail(function(err) {
            const unreachable = window.fiaIsUnreachable(err);
            window.fiaLogClientError('reset_password', {
                message:    unreachable
                    ? 'Request never reached the backend (network or CORS block)'
                    : (err.responseJSON && err.responseJSON.error) || 'reset start failed',
                httpStatus: err.status || 0,
                email:      email,
                detail:     err.statusText
            });
            let message = unreachable
                ? window.FIA_UNREACHABLE_MESSAGE
                : 'Could not start password reset. Please try again.';
            if (err.responseJSON && err.responseJSON.error) {
                message = err.responseJSON.error;
            }
            showError(message);
        }).always(function() {
            $submitBtn.text('Send reset code').prop('disabled', false);
        });
    });

    // STEP 2: submit code + new password -> backend /complete -> auto-login token
    $confirmBtn.on('click', function() {
        clearMessages();

        const code            = $('#reset-code').val().trim();
        const newPassword     = $('#reset-new-password').val();
        const confirmPassword = $('#reset-confirm-password').val();

        if (!code) {
            showError('Please enter the reset code from your email.');
            return;
        }
        if (newPassword !== confirmPassword) {
            showError('Passwords do not match!');
            return;
        }
        if (newPassword.length < 8) {
            showError('Password must be at least 8 characters long.');
            return;
        }
        if (!resetState.continuationToken) {
            showError('This email may not have an account, or your session expired. Please start again.');
            return;
        }

        $confirmBtn.text('Resetting...').prop('disabled', true);

        $.ajax({
            url: RESET_API_BASE + '/complete',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                email: resetState.email,
                code: code,
                newPassword: newPassword,
                continuationToken: resetState.continuationToken
            })
        }).done(function(response) {
            $confirmBtn.text('Success!').css('background', '#27ae60');
            $successMsg.fadeIn();

            const token = response.token || response.access_token;
            if (token) {
                localStorage.setItem('authToken', token);
                setTimeout(function() { window.location.href = '/user-profile'; }, 1200);
            } else {
                setTimeout(function() { window.location.href = '/login/?reset=1'; }, 1500);
            }
        }).fail(function(err) {
            let message = 'Could not reset the password. Please check the code and try again.';
            const pwMessage = getPasswordErrorMessage(err.responseJSON);
            if (pwMessage) {
                message = pwMessage;
            }
            showError(message);
            $confirmBtn.text('Reset password').prop('disabled', false);
        });
    });

    $('#reset-code, #reset-new-password, #reset-confirm-password').on('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); $confirmBtn.click(); }
    });

    $backBtn.on('click', function() {
        clearMessages();
        resetState.continuationToken = null;
        $stepCode.hide();
        $stepEmail.show();
        $confirmBtn.text('Reset password').prop('disabled', false).css('background', '');
    });
});


// Report Builder
jQuery(document).ready(function($) {

    // Include icons & Render Links
    function getFileIcon(type) {
        const icons = {
            'word': 'https://cdn-icons-png.flaticon.com/512/888/888883.png',
            'pdf': 'https://cdn-icons-png.flaticon.com/512/337/337946.png',
            'excel': 'https://cdn-icons-png.flaticon.com/512/888/888850.png',
            'default': 'https://cdn-icons-png.flaticon.com/512/1091/1091916.png'
        };
        return icons[type] || icons['default'];
    }

    // Escape a raw document title before it goes into markup. Titles come from
    // the document store and contain characters that are legal in a filename but
    // not in an attribute value (quotes, angle brackets, "&"). The previous
    // version interpolated link.name straight into title="..." — a title
    // containing a double quote broke out of the attribute and swallowed the rest
    // of the tag, which is also one of the ways a name can look "cut off".
    function escapeAttr(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    // "30 Jun 2026" — short, unambiguous, no locale surprises.
    const LINK_DATE_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function formatLinkDate(isoString) {
        if (!isoString) return null;
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return null;
        return `${date.getUTCDate()} ${LINK_DATE_MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
    }

    function renderLinksHtml(links) {
        if (!links || !Array.isArray(links) || !links.length) return '';
        const VIEW_URL = `${window.location.origin}/view-document/`;

        return `
    <div class="mt-2 d-flex flex-column align-items-start gap-2">
        ${links.map(link => {
            const fullHref = `${VIEW_URL}?doc=${link.documentId}&ver=${link.versionId}`;

            const iconSrc = (typeof getFileIcon === 'function')
                ? getFileIcon(link.icon)
                : 'https://cdn-icons-png.flaticon.com/512/1091/1091916.png';

            const rawName = link.name || 'Document';

            // The backend already ordered every section newest-first. Showing the
            // date it sorted on makes that order visible — and gives a readable
            // date to documents whose stored title lost its "(as of ...)" suffix.
            // sortDateSource distinguishes a date printed in the title from a
            // fallback upload date, so we never present an upload date as if it
            // were the document's own "as of" date.
            const dateLabel = formatLinkDate(link.sortDate);
            const isUploadDate = link.sortDateSource === 'publication';

            const dateHtml = dateLabel
                ? `<span class="link-date-badge ms-1 text-muted" style="font-size: 10px; white-space: nowrap; flex: 0 0 auto;">${isUploadDate ? 'uploaded ' : ''}${dateLabel}</span>`
                : '';

            const tooltip = dateLabel
                ? `${rawName} — ${isUploadDate ? 'uploaded ' : ''}${dateLabel}`
                : rawName;

            // align-items-start + white-space: normal + text-align: left let the
            // full title wrap onto as many lines as it needs. Bootstrap's .btn
            // sets white-space: nowrap, which in a narrow comparison column
            // pushed long titles out of the visible area instead of wrapping —
            // the name was never shortened, just clipped by the overflow.
            return `
                <a href="${fullHref}"
                   class="btn btn-sm btn-outline-light text-navy d-inline-flex align-items-start gap-1 border text-start"
                   target="_blank"
                   style="white-space: normal; text-align: left; max-width: 100%; word-break: break-word;"
                   title="${escapeAttr(tooltip)}">
                    <img src="${iconSrc}" width="16" height="16" alt="icon" style="flex: 0 0 auto; margin-top: 1px;">
                    <span style="font-size: 11px;">${rawName}</span>
                    ${dateHtml}
                </a>
            `;
        }).join('')}
    </div>`;
    }


    // CONFIGURATION AND VARIABLES
    const CONFIG = {
        API_BASE: '/api/ai/survey',
        MODULE_CODE: window.SURVEY_MODULE_CODE || 'base',
        CONTAINERS: {
            TREE: '.survey-tree',
            ACCORDION: '#survey-accordion',
            NEXT_BTN: '.btn-next-step'
        },
        // Comparison report — takes a list of services and questions.
        EXPORT_EXCEL: '/api/ai/survey/generateReportAsExcel',
        EXPORT_CSV: '/api/ai/survey/generateReportAsCSV',
        EXPORT_PDF: '/api/ai/survey/generateReportAsPDF',

        // Single-service report — takes one service and returns the whole
        // questionnaire for it. Separate endpoints because the request body is a
        // different shape, not because the formats differ.
        EXPORT_SERVICE_EXCEL: '/api/ai/survey/generateReportForServiceAsExcel',
        EXPORT_SERVICE_CSV: '/api/ai/survey/generateReportForServiceAsCSV',
        EXPORT_SERVICE_PDF: '/api/ai/survey/generateReportForServiceAsPDF'
    };

    // How tall a report answer may be before it is clamped behind Show more.
    // Roughly ten lines: short answers are untouched, long ones stop pushing the
    // services being compared off the screen. Used by the markup and by the two
    // places that measure and reset it, so the three cannot drift apart.
    const ANSWER_CLAMP_PX = 300;

    // Drawn inline rather than fetched. The Excel and CSV buttons beside it pull
    // their icons from cdn-icons-png.flaticon.com, so every report view reaches
    // out to a third party that has no reason to know which FIA pages a member
    // firm is reading — and that breaks the button the day the CDN is unreachable.
    // Not changing those two here, but not adding a third.
    const PDF_ICON_SVG =
        '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<path d="M4 1.5h5L13 5.5v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1z" ' +
        'stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
        '<path d="M9 1.5V5.5H13" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
        '<text x="8" y="12.6" font-size="5.2" font-weight="700" text-anchor="middle" ' +
        'fill="currentColor" font-family="Arial, sans-serif">PDF</text></svg>';

    const TOKEN = localStorage.getItem('authToken');
    let availableServices = [];

    // 1. INITIAL DATA LOAD
    async function initSurveyPage() {
        if (!TOKEN) {
            handleUnauthorized();
            return;
        }

        const headers = { 'Authorization': `Bearer ${TOKEN}`, 'Content-Type': 'application/json' };

        try {
            const [qRes, sRes] = await Promise.all([
                fetch(`${CONFIG.API_BASE}/questions/${CONFIG.MODULE_CODE}`, { headers }),
                fetch(`${CONFIG.API_BASE}/services/${CONFIG.MODULE_CODE}/all`, { headers })
            ]);

            if (qRes.status === 401 || sRes.status === 401) {
                handleUnauthorized();
                return;
            }

            if (!qRes.ok || !sRes.ok) throw new Error('Failed to fetch data');

            const questionsData = await qRes.json();
            const servicesData = await sRes.json();

            let flattened = [];
            if (servicesData.items && Array.isArray(servicesData.items)) {
                servicesData.items.forEach(node => {
                    if (node.type === 'group' && node.items && Array.isArray(node.items)) {
                        node.items.forEach(subItem => {
                            flattened.push(subItem.name);
                        });
                    } else if (node.type === 'entry') {
                        flattened.push(node.name);
                    } else {
                        flattened.push(typeof node === 'object' ? (node.name || node.text) : node);
                    }
                });
            }
            availableServices = [...new Set(flattened)];
            // ------------------------------------

            renderServiceSelection();
            renderSurveyTree(questionsData);
        } catch (error) {
            console.error("Survey init error:", error);
            showInlineError("Data is temporarily unavailable. Check connection.");
        }
    }

    function handleUnauthorized() {
        localStorage.removeItem('authToken');
        showInlineError("Your session has expired. Please log in again to continue.", true);
        $(CONFIG.CONTAINERS.ACCORDION).empty();
        $(CONFIG.CONTAINERS.NEXT_BTN).prop('disabled', true);
    }

    // The API keeps error details in its server log (F-08): a 5xx answer
    // carries only a reference id, which is what support needs.
    function serverErrorText(data, status) {
        if (status >= 500) {
            return 'Something went wrong on our side. Please try again'
                + (data && data.requestId ? ` (reference ${data.requestId}).` : '.');
        }
        return (data && data.error) || `Request failed (status ${status}).`;
    }

    function showInlineError(msg, showLoginBtn = false) {
        $('.error-msg-banner').remove();
        let loginButtonHtml = showLoginBtn ? `<div class="mt-2"><a href="/login" class="btn btn-primary btn-sm">Go to Login</a></div>` : '';
        const banner = `<div class="error-msg-banner alert alert-warning alert-dismissible fade show mb-3" role="alert">
            <div>${msg}</div>${loginButtonHtml}<button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>`;
        $(CONFIG.CONTAINERS.TREE).before(banner);
    }

    // RENDER SERVICE SELECTION WITH "FULL REPORT" BUTTON

// 1. INITIAL DATA LOAD
    async function initSurveyPage() {
        if (!TOKEN) {
            handleUnauthorized();
            return;
        }

        const headers = { 'Authorization': `Bearer ${TOKEN}`, 'Content-Type': 'application/json' };

        // --- Page-level access gate ---
        // Logged-in users with no rights for this module see the same banner as
        // the not-logged-in case, but without a "Go to Login" button. Backend
        // still enforces access on every report route; this is UX only.
        try {
            const accessRes = await fetch(`${CONFIG.API_BASE}/access/${CONFIG.MODULE_CODE}`, { headers });

            if (accessRes.status === 401) { handleUnauthorized(); return; }

            const accessData = await accessRes.json();
            if (!accessData.hasAccess) {
                showInlineError("You don't have access to reports for this section. Please contact your administrator.");
                $(CONFIG.CONTAINERS.TREE).hide();
                $(CONFIG.CONTAINERS.ACCORDION).empty();
                $(CONFIG.CONTAINERS.NEXT_BTN).prop('disabled', true);
                return; // stop — do not render the report builder
            }
        } catch (e) {
            console.error("Access check failed:", e);
            showInlineError("Unable to verify access right now. Please try again later.");
            return;
        }
        // --- end gate ---

        try {
            const [qRes, sRes] = await Promise.all([
                fetch(`${CONFIG.API_BASE}/questions/${CONFIG.MODULE_CODE}`, { headers }),
                fetch(`${CONFIG.API_BASE}/services/${CONFIG.MODULE_CODE}/all`, { headers })
            ]);

            if (qRes.status === 401 || sRes.status === 401) {
                handleUnauthorized();
                return;
            }

            if (!qRes.ok || !sRes.ok) throw new Error('Failed to fetch data');

            const questionsData = await qRes.json();
            const servicesData = await sRes.json();

            if (servicesData && servicesData.items && Array.isArray(servicesData.items)) {
                availableServices = servicesData.items;
            } else {
                availableServices = [];
            }

            renderServiceSelection();
            renderSurveyTree(questionsData);

            // Opened via a shared link? Render that report straight away.
            await loadSharedReportFromUrl();
        } catch (error) {
            console.error("Survey init error:", error);
            showInlineError("Data is temporarily unavailable. Check connection.");
        }
    }

    // SHAREABLE LINK: ?report=<linkId> reopens a previously shared report.
    // The stored link holds only the selection, so the report is regenerated from
    // current data and the backend re-checks this user's own entitlements.
    async function loadSharedReportFromUrl() {
        const linkId = new URLSearchParams(window.location.search).get('report');
        if (!linkId) return;

        try {
            const response = await fetch(
                `${CONFIG.API_BASE}/generateReport/link/${encodeURIComponent(linkId)}`,
                { headers: { 'Authorization': `Bearer ${TOKEN}`, 'Content-Type': 'application/json' } }
            );

            if (response.status === 401) { handleUnauthorized(); return; }

            const data = await response.json().catch(() => ({}));

            if (response.status === 404) {
                showInlineError("This report link is no longer valid.");
                return;
            }
            if (response.status === 403) {
                const blocked = (data.deniedServices || []).join(', ');
                showInlineError(`${data.error || 'You are not subscribed to some of the services in this report.'}${blocked ? ' (' + blocked + ')' : ''}`);
                return;
            }
            if (!response.ok) throw new Error(serverErrorText(data, response.status));

            renderReportResults(data, data.services || [], data.questions || []);
        } catch (error) {
            console.error("Shared report load error:", error);
            showInlineError("Could not open the shared report. Please try again.");
        }
    }

    // RENDER SERVICE SELECTION
    function renderServiceSelection() {
        $('.service-selection-wrapper, .service-label-q').remove();
        $('#select-all-q').closest('.d-flex').remove();

        let idx = 0;
        let htmlContent = '';

        const getServiceName = item => {
            if (!item) return '';

            if (typeof item === 'string') {
                return item;
            }

            return item.name || item.text || '';
        };

        // A service the organisation is not subscribed to. The backend sends
        // entitled:false for these (REPORT_SERVICE_LIST_MODE=mark). A missing
        // field means the backend is filtering instead, so treat it as entitled.
        const isLocked = item => item && item.entitled === false;

        const LOCK_BADGE = '<span class="badge bg-light text-muted border ms-2" style="font-weight:500;">Not in your subscription</span>';

        const sortAlphabetically = (a, b) => {
            return getServiceName(a).localeCompare(getServiceName(b), undefined, {
                sensitivity: 'base',
                numeric: true
            });
        };

        if (!availableServices || !availableServices.length) {
            // HOTFIX: the list is now filtered to the organisation's subscribed
            // services, so "empty" almost always means "no subscription", not a bug.
            htmlContent = '<p class="p-3 text-muted mb-0">No services available for this section. Please contact your administrator.</p>';
        } else {
            const sortedServices = [...availableServices].sort(sortAlphabetically);

            htmlContent = sortedServices.map(node => {
                if (node.type === 'group') {
                    // Children of a group are sorted alphabetically too
                    const sortedChildren = [...(node.items || [])].sort(sortAlphabetically);

                    const childItemsHtml = sortedChildren.map(child => {
                        idx++;

                        const childName = getServiceName(child);
                        const childLocked = isLocked(child);

                        return `
                    <div class="form-check p-2 border-bottom service-item child-service-item d-flex justify-content-between align-items-center mb-0${childLocked ? ' service-item-locked' : ''}"
                         style="cursor:${childLocked ? 'not-allowed' : 'pointer'}; padding-left: 2.5rem !important; background-color: #fcfcfc;${childLocked ? ' opacity:0.55;' : ''}"
                         ${childLocked ? 'title="Not included in your subscription. Please contact your administrator."' : ''}>
                        <div class="d-flex align-items-center">
                            <input class="form-check-input service-check ms-0" type="checkbox" value="${childName}" id="svc-${idx}"${childLocked ? ' disabled' : ''}>
                            <label class="form-check-label d-block ps-4${childLocked ? '' : ' cursor-pointer'}" for="svc-${idx}">${childName}${childLocked ? LOCK_BADGE : ''}</label>
                        </div>
                        ${childLocked ? '' : `<button type="button" class="btn btn-sm btn-link text-navy text-decoration-none view-single-report" data-service="${childName}">
                            <small>Full Report</small>
                        </button>`}
                    </div>`;
                    }).join('');

                    return `
                <div class="service-group-container">
                    <div class="service-group-header d-flex align-items-center justify-content-between py-2 px-1 bg-light cursor-pointer">
                        <div class="d-flex align-items-center gap-2">
                            <span class="arrow-icon badge-toggle">
                                <svg class="chevron-icon" width="12" height="12" viewBox="0 0 16 10" fill="none" style="transform: rotate(0deg); transition: transform 0.2s;">
                                    <path d="M1 1L8 8L15 1" stroke="#294661" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                            </span>
                            <input type="checkbox" class="form-check-input service-group-check">
                            <span class="fw-bold text-navy small text-uppercase ms-1">${getServiceName(node)}</span>
                        </div>
                    </div>
                    <div class="service-group-content" style="display: block;">
                        ${childItemsHtml}
                    </div>
                </div>`;
                } else {
                    idx++;

                    const entryName = getServiceName(node);
                    const entryLocked = isLocked(node);

                    return `
                <div class="form-check p-2 border-bottom service-item d-flex justify-content-between align-items-center mb-0 px-3${entryLocked ? ' service-item-locked' : ''}"
                     style="cursor:${entryLocked ? 'not-allowed' : 'pointer'};${entryLocked ? ' opacity:0.55;' : ''}"
                     ${entryLocked ? 'title="Not included in your subscription. Please contact your administrator."' : ''}>
                    <div class="d-flex align-items-center">
                        <input class="form-check-input service-check ms-0" type="checkbox" value="${entryName}" id="svc-${idx}"${entryLocked ? ' disabled' : ''}>
                        <label class="form-check-label d-block ps-4${entryLocked ? '' : ' cursor-pointer'}" for="svc-${idx}">${entryName}${entryLocked ? LOCK_BADGE : ''}</label>
                    </div>
                    ${entryLocked ? '' : `<button type="button" class="btn btn-sm btn-link text-navy text-decoration-none view-single-report" data-service="${entryName}">
                        <small>Full Report</small>
                    </button>`}
                </div>`;
                }
            }).join('');
        }

        const selectionHtml = `
    <div class="service-selection-wrapper mb-4 p-3 border rounded bg-light">
        <label class="fw-bold text-navy mb-2 d-block">1. SELECT SERVICES</label>
        <div id="service-list-container" class="bg-white border rounded shadow-sm" style="max-height: 450px; overflow-y: auto;">
            ${htmlContent}
        </div>
        <small class="text-muted d-block mt-2">Selected: <span id="selected-count" class="fw-bold text-primary">0</span></small>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-2 service-label-q">
        <label class="fw-bold text-navy mb-0">2. SELECT QUESTIONS</label>
        <button type="button" id="select-all-q" class="btn text-decoration-underline text-navy">Select all</button>
    </div>`;

        $(CONFIG.CONTAINERS.TREE).before(selectionHtml);


        $('#service-list-container').off('click', '.service-item').on('click', '.service-item', function(e) {
            if (!$(e.target).closest('input, button').length) {
                const $check = $(this).find('input.service-check');
                // Locked rows render a disabled checkbox — clicking the row must not toggle it.
                if ($check.prop('disabled')) return;
                $check.prop('checked', !$check.prop('checked')).trigger('change');
            }
        });

        $('#service-list-container').off('change', '.service-check').on('change', '.service-check', function() {
            $(this).closest('.service-item').toggleClass('bg-aliceblue', this.checked);

            $('#selected-count').text($('.service-check:checked:not(:disabled)').length);

            const $groupContainer = $(this).closest('.service-group-container');

            if ($groupContainer.length) {
                // Locked services are excluded from the group tally, otherwise a
                // group containing any of them could never reach "all selected".
                const totalInGroup = $groupContainer.find('.service-check:not(:disabled)').length;
                const checkedInGroup = $groupContainer.find('.service-check:checked:not(:disabled)').length;
                const $groupHeaderCheck = $groupContainer.find('.service-group-check');

                if (checkedInGroup === totalInGroup) {
                    $groupHeaderCheck.prop('checked', true).prop('indeterminate', false);
                } else if (checkedInGroup > 0) {
                    $groupHeaderCheck.prop('checked', false).prop('indeterminate', true);
                } else {
                    $groupHeaderCheck.prop('checked', false).prop('indeterminate', false);
                }
            }

            updateNextButtonState();
        });

        $('#service-list-container').off('change', '.service-group-check').on('change', '.service-group-check', function() {
            const isChecked = this.checked;
            const $groupContainer = $(this).closest('.service-group-container');

            $groupContainer.find('.service-check:not(:disabled)').each(function() {
                if ($(this).prop('checked') !== isChecked) {
                    $(this).prop('checked', isChecked).trigger('change');
                }
            });
        });

        $('#service-list-container').off('click', '.service-group-header').on('click', '.service-group-header', function(e) {
            if ($(e.target).is('input')) return;

            const $content = $(this).next('.service-group-content');
            const $chevron = $(this).find('.chevron-icon');

            $content.slideToggle(200, function() {
                if ($(this).is(':visible')) {
                    $chevron.css('transform', 'rotate(0deg)');
                } else {
                    $chevron.css('transform', 'rotate(-90deg)');
                }
            });
        });

        // 5. Select all, for the questions
        $(document).off('click', '#select-all-q').on('click', '#select-all-q', function(e) {
            e.preventDefault();

            const $qCheckboxes = $('.q-check');
            const isAnyUnchecked = $qCheckboxes.filter(':not(:checked)').length > 0;

            $('#survey-accordion')
                .find('input[type="checkbox"]')
                .prop('checked', isAnyUnchecked)
                .trigger('change');

            if (isAnyUnchecked) {
                $('.group-content, .questions-list').show();
            }

            $(this).text(isAnyUnchecked ? 'Deselect all' : 'Select all');

            updateNextButtonState();
        });
    }

    // HANDLER FOR SINGLE SERVICE REPORT
    $(document).off('click', '.view-single-report').on('click', '.view-single-report', async function(e) {
        e.stopPropagation();
        const serviceName = $(this).data('service');
        const $btn = $(this);
        const originalHtml = $btn.html();

        $btn.html('<span class="spinner-border spinner-border-sm"></span>').prop('disabled', true);

        try {
            const response = await fetch(`${CONFIG.API_BASE}/generateReportForService`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${TOKEN}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ "moduleCode": CONFIG.MODULE_CODE, "service": serviceName })
            });

            if (response.status === 401) { handleUnauthorized(); return; }

            if (!response.ok) {
                const errData = await response.json().catch(() => ({}));
                // HOTFIX: 403 + SERVICE_NOT_ENTITLED means the organisation is not
                // subscribed to this service. Show the reason instead of a generic
                // "Server error", which reads like an outage.
                if (response.status === 403 && errData.code === 'SERVICE_NOT_ENTITLED') {
                    const blocked = (errData.deniedServices || [serviceName]).join(', ');
                    throw new Error(`${errData.error || 'You are not subscribed to this service.'} (${blocked}) Please contact your administrator.`);
                }
                throw new Error(serverErrorText(errData, response.status));
            }

            const result = await response.json();
            const dataToRender = Array.isArray(result) ? result : (result.result || result.items || []);

            if (!dataToRender || dataToRender.length === 0) {
                throw new Error("Report is empty for this service.");
            }

            renderSingleServiceReport(serviceName, dataToRender);
        } catch (error) {
            showInlineError(error.message);
        } finally {
            $btn.html(originalHtml).prop('disabled', false);
        }
    });

    // ── Normalise answer HTML so nested tables don't collapse the outer report table ──
    // Root cause: when answer HTML contains stray text/whitespace nodes sitting DIRECTLY
    // inside <table>/<thead>/<tbody>/<tfoot>/<tr> (i.e. not inside a <td>/<th>), or rows
    // that aren't wrapped in <tbody>, the browser's HTML parser EJECTS those nodes out of
    // the table when the markup is inserted into the outer report table's <td>. That ejection
    // drops rows and produces the "1 2 / 1 2 collapsed into bare text" symptom (table-in-table).
    //
    // We fix it by parsing the answer HTML in ISOLATION (its own document, not inside the
    // outer table), letting the parser repair each table, removing illegal stray children of
    // table-structural elements, and guaranteeing every table has a <tbody>. The re-serialised
    // markup is then safe to drop into the outer report <td>.
    function normalizeReportHtml(html) {
        if (!html || html.indexOf('<table') === -1) return html; // nothing table-related → leave untouched
        try {
            var doc = new DOMParser().parseFromString('<div id="__rc_root">' + html + '</div>', 'text/html');
            var root = doc.getElementById('__rc_root');
            if (!root) return html;

            var isWhitespace = function (n) { return n.nodeType === 3 && !/\S/.test(n.textContent || ''); };

            // 0) Lift tables out of invalid parents (headings, paragraphs, inline elements).
            //    A <table> inside <h2>/<p>/<span>/<a>/<b>… is invalid HTML — the browser ejects
            //    the table from such a parent, which (inside the outer report table) collapses it
            //    into bare text. This is how "Heading 2" applied over a table produced "1 2 / 1 2".
            //    We split the parent around the table so content before/after keeps its styling.
            var INVALID_TABLE_PARENTS = ['h1','h2','h3','h4','h5','h6','p','span','a','b','i','em','strong','u','s','strike','sub','sup','small','code','label','button','mark'];
            (function () {
                var moved = true, guard = 0;
                while (moved && guard++ < 100) {
                    moved = false;
                    var tables = Array.prototype.slice.call(root.querySelectorAll('table'));
                    for (var t = 0; t < tables.length; t++) {
                        var table = tables[t];
                        var parent = table.parentNode;
                        if (!parent || parent === root) continue;
                        var ptag = parent.tagName ? parent.tagName.toLowerCase() : '';
                        if (INVALID_TABLE_PARENTS.indexOf(ptag) === -1) continue;
                        var grandparent = parent.parentNode;
                        if (!grandparent) continue;

                        // Move everything after the table into a clone of the parent (keeps before/after split).
                        var afterClone = parent.cloneNode(false);
                        var n = table.nextSibling;
                        while (n) { var next = n.nextSibling; afterClone.appendChild(n); n = next; }

                        grandparent.insertBefore(table, parent.nextSibling);
                        if (afterClone.childNodes.length) grandparent.insertBefore(afterClone, table.nextSibling);

                        // Drop now-empty "before" and "after" shells.
                        if (!parent.textContent.trim() && parent.children.length === 0) parent.remove();
                        if (afterClone.parentNode && !afterClone.textContent.trim() && afterClone.children.length === 0) afterClone.remove();

                        moved = true;
                        break; // structure changed — re-query
                    }
                }
            })();

            // 1) Pull any loose <tr> directly under <table> into a <tbody>.
            root.querySelectorAll('table').forEach(function (table) {
                var looseRows = Array.prototype.filter.call(table.children, function (c) {
                    return c.tagName && c.tagName.toLowerCase() === 'tr';
                });
                if (looseRows.length) {
                    var tbody = table.querySelector(':scope > tbody');
                    if (!tbody) {
                        tbody = doc.createElement('tbody');
                        table.insertBefore(tbody, looseRows[0]);
                    }
                    looseRows.forEach(function (r) { tbody.appendChild(r); });
                }
            });

            // 2) Remove illegal direct children of <table>/<thead>/<tbody>/<tfoot>.
            //    Whitespace/comments/stray text are dropped; meaningful stray text is salvaged
            //    into a single-cell row so no typed content is lost.
            root.querySelectorAll('table, thead, tbody, tfoot').forEach(function (el) {
                var isTable = el.tagName.toLowerCase() === 'table';
                var allowed = isTable
                    ? ['thead', 'tbody', 'tfoot', 'tr', 'caption', 'colgroup']
                    : ['tr'];
                Array.prototype.slice.call(el.childNodes).forEach(function (child) {
                    var tag = child.nodeType === 1 ? child.tagName.toLowerCase() : '';
                    if (child.nodeType === 1 && allowed.indexOf(tag) !== -1) return;
                    if (isWhitespace(child) || child.nodeType === 8) { child.remove(); return; }
                    if (child.nodeType === 3 && child.textContent.trim()) {
                        // Salvage stray text into a proper row so the table stays valid.
                        var host = isTable ? (el.querySelector(':scope > tbody') || el) : el;
                        if (isTable && host === el) {
                            host = doc.createElement('tbody');
                            el.appendChild(host);
                        }
                        var tr = doc.createElement('tr');
                        var td = doc.createElement('td');
                        td.textContent = child.textContent.trim();
                        tr.appendChild(td);
                        (isTable ? host : el).appendChild(tr);
                    }
                    child.remove();
                });
            });

            // 3) Remove stray nodes directly inside <tr> that aren't <td>/<th>.
            root.querySelectorAll('tr').forEach(function (tr) {
                Array.prototype.slice.call(tr.childNodes).forEach(function (child) {
                    var tag = child.nodeType === 1 ? child.tagName.toLowerCase() : '';
                    if (child.nodeType === 1 && (tag === 'td' || tag === 'th')) return;
                    if (child.nodeType === 3 && child.textContent.trim()) {
                        // Wrap stray text in a cell rather than dropping it.
                        var td = doc.createElement('td');
                        td.textContent = child.textContent.trim();
                        tr.insertBefore(td, child);
                    }
                    child.remove();
                });
            });

            // 4) Remove empty heading/paragraph shells left behind by the unwrap step
            //    (e.g. an <h2><p></p></h2> wrapper that only held the now-lifted table).
            //    Process innermost-first (reverse order) so a parent is re-checked after its
            //    empty children are removed.
            Array.prototype.slice.call(root.querySelectorAll('h1,h2,h3,h4,h5,h6,p')).reverse().forEach(function (el) {
                if (el.querySelector('table')) return;
                var inner = el.innerHTML.replace(/&nbsp;|\u00a0|<br\s*\/?>/gi, '').trim();
                if (inner === '') el.remove();
            });

            return root.innerHTML;
        } catch (e) {
            // If anything goes wrong, fall back to the original markup unchanged.
            return html;
        }
    }

    // RENDERER FOR SINGLE SERVICE REPORT (Filer out N/A)
    function renderSingleServiceReport(serviceName, data) {
        if (!Array.isArray(data)) return;

        // ---- Exclude specific question groups from the report ----------------
        // Group names carry a trailing numeric id (see renderSurveyTree, which
        // strips it with /\s+\d+$/ for display). In the report the same group
        // arrives as a `heading` item whose `text` ends in that id. We drop the
        // matching heading and every item nested beneath it, up to the next
        // heading at the same or a shallower level.
        const EXCLUDED_GROUP_IDS = ['1099'];
        const trailingId = s => {
            const m = String(s == null ? '' : s).trim().match(/(\d+)$/);
            return m ? m[1] : null;
        };
        if (EXCLUDED_GROUP_IDS.length) {
            const filtered = [];
            let skipBelowLevel = null; // when set, drop items deeper than this level
            data.forEach(item => {
                const lvl = item.level || 0;
                if (skipBelowLevel !== null) {
                    // Still inside the excluded group's subtree?
                    if (lvl > skipBelowLevel) return;
                    skipBelowLevel = null; // reached a sibling/ancestor: stop skipping
                }
                if (item.type === 'heading' &&
                    EXCLUDED_GROUP_IDS.indexOf(trailingId(item.text)) !== -1) {
                    skipBelowLevel = lvl; // drop this heading and its descendants
                    return;
                }
                filtered.push(item);
            });
            data = filtered;
        }
        // ----------------------------------------------------------------------

        let rowsHtml = data.map(item => {
            const padding = (item.level || 0) * 20;

            if (item.type === 'heading') {
                return `<tr><td colspan="2" class="bg-light fw-bold text-navy" style="padding-left: ${padding + 12}px; border-top: 1px solid #dee2e6;">${item.text}</td></tr>`;
            } else {
                // Prefer the rich HTML the backend sends; fall back to plain text.
                const rawHtml = item.answerHtml ? String(item.answerHtml).trim() : '';
                const rawText = item.answer ? String(item.answer).trim() : '';

                const isNa = s => {
                    const u = s.toUpperCase();
                    return u === 'N/A' || u === 'NA';
                };

                const hasAnswer = (!!rawHtml || !!rawText) && !isNa(rawText);
                const hasLinks = item.links && Array.isArray(item.links) && item.links.length > 0;

                // Every question stays in the report, answered or not.
                //
                // This row used to drop the whole question when there was no
                // answer, and also when the answer was literally "N/A" — so a
                // requirement that had been considered and found not to apply
                // looked identical to one that was never in the survey. A reader
                // working through a report end to end had no way to tell the
                // difference, and no way to know anything was missing at all: on
                // the NGX Base Module that silently removed 166 of 374 questions.
                //
                // Asked for by FIA on 09.10.2026, and N/A is their wording.

                // Post-process: strip □□ chars, fix bold-merge, remove <font> tags.
                const processedHtml = rawHtml ? (() => {
                    let h = rawHtml;
                    h = h.replace(/<font[^>]*>/gi, '').replace(/<\/font>/gi, '');
                    h = h.replace(/<\/(strong|em|b|i|u|sup|sub)>([a-zA-Z0-9À-ɏ,;:!?])/g, '</$1> $2');
                    h = h.replace(/([a-zA-Z0-9À-ɏ,;])<(strong|em|b|i|u|sup|sub)(\s|>)/g, '$1 <$2$3');
                    h = h.replace(/(<li>|<p>)([\u25A0-\u25FF\u2610-\u2612\uFFFD]+[)\s,]*)/g, '$1');
                    h = h.replace(/<span>\s*<\/span>/gi, '');
                    // Repair any tables so nested tables don't collapse the outer report table.
                    h = normalizeReportHtml(h);
                    return h;
                })() : null;
                const answerCell = processedHtml
                    ? processedHtml
                    : rawText.replace(/\n/g, '<br>');

                const linksHtml = renderLinksHtml(item.links);

                // Same clamp as the comparison report: some answers here run to
                // dozens of paragraphs, and a requirement whose answer fills three
                // screens buries the ones after it.
                const answerHtml = hasAnswer ? `
                    <div class="answer-wrapper position-relative">
                        <div class="answer-text" style="max-height: ${ANSWER_CLAMP_PX}px; overflow: hidden; transition: max-height 0.25s ease;">${answerCell}</div>
                        <div class="read-more-overlay" style="position: absolute; bottom: 0; left: 0; width: 100%; height: 45px; background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.9) 40%, rgba(255, 255, 255, 1) 100%); display: none; pointer-events: none;"></div>
                        <a href="javascript:void(0);" class="read-more-btn text-decoration-none small fw-bold mt-1" data-expanded="false" style="color: #00a3c4; display: none; position: relative; z-index: 2;">Show more</a>
                    </div>`
                    // No answer, and no attachments standing in for one. Plain
                    // text, deliberately: a greyed-out or italic N/A would read as
                    // a note from us about the survey rather than as the survey's
                    // own answer, which is what it is.
                    : (hasLinks ? '' : 'N/A');

                return `<tr>
                <td class="ps-4" style="padding-left: ${padding + 12}px; width: 40%; font-size: 0.95rem;">${item.question}</td>
                <td>
                    ${answerHtml}
                    ${linksHtml}
                </td>
            </tr>`;
            }
        }).join('');

        const finalHtml = `
    <style>
        /* bg-navy / text-navy are not part of Bootstrap and are undefined in the
           theme CSS. The header row uses the same navy text as the group rows
           (text-navy), on a transparent background instead of a navy bar. */
        .report-container .text-navy { color: #294661 !important; }
        .report-container thead.bg-navy { background-color: transparent !important; }
        .report-container thead.bg-navy th { color: #294661 !important; border-bottom: 2px solid #dee2e6; }
        .report-container td ul,
        .report-container td ol  { padding-left: 1.5em; margin: 0.2em 0; }
        .report-container td li  { word-break: break-word; list-style-position: inside; }
        .report-container td p   { margin-bottom: 0.35em; word-break: break-word; }
        /* Style tables nested inside an answer cell so they read as tables (they carry no class). */
        .report-container td table { border-collapse: collapse; width: 100%; margin: 0.4em 0; }
        .report-container td table td,
        .report-container td table th { border: 1px solid #c5ccd3; padding: 6px 10px; vertical-align: top; text-align: left; }
        .report-container td table th { background: #f3f5f7; font-weight: 600; }
        .report-container td table tr:nth-child(even) td { background: #fafbfc; }
        /* Document links: one chip per line (never sit two side by side). */
        .report-container td > div:has(> a.btn-outline-light),
        .report-container td .service-answer-block > div:has(> a.btn-outline-light) {
            display: flex; flex-direction: column; align-items: flex-start; gap: 0.5rem;
        }
        .report-container a.btn-outline-light { display: inline-flex; max-width: 100%; white-space: normal; text-align: left; }
    </style>
    <div class="report-container mt-5 p-4 border rounded bg-white shadow-sm">
        <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2 flex-wrap gap-2">
            <h3 class="text-navy mb-0">Service Report: ${serviceName}</h3>
            <div class="d-flex align-items-center gap-2">
                <button type="button" class="btn btn-sm btn-outline-success d-flex align-items-center gap-1 btn-export-service" data-type="excel">
                    <span>Export Excel</span>
                </button>
                <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 btn-export-service" data-type="csv">
                    <span>Export CSV</span>
                </button>
                <button type="button" class="btn btn-sm btn-outline-danger d-flex align-items-center gap-1 btn-export-service" data-type="pdf">
                    ${PDF_ICON_SVG}
                    <span>Export PDF</span>
                </button>
                <button type="button" class="btn-close" onclick="$('.report-container').remove()"></button>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered align-middle">
                <thead class="bg-navy text-white">
                    <tr><th>Requirement</th><th>Details</th></tr>
                </thead>
                <tbody>${rowsHtml || '<tr><td colspan="2" class="text-center">No data found or all results are N/A.</td></tr>'}</tbody>
            </table>
        </div>
    </div>`;


        $('.report-container').remove();
        $(CONFIG.CONTAINERS.ACCORDION).after(finalHtml);
        // Reveals Show more on the answers that overflow. Measured after insertion,
        // because scrollHeight is meaningless while the markup is still a string.
        initReadMoreTriggers();
        initServiceExportButtons(serviceName);
        $('html, body').animate({ scrollTop: $(".report-container").offset().top - 50 }, 500);
    }

    /**
     * Download buttons on the single-service report.
     *
     * Kept apart from the comparison report's handler rather than shared: that one
     * posts a list of services and questions, this one posts one service and gets
     * the whole questionnaire back. Folding both into one function would mean a
     * branch on report type inside every step, and the two reports have already
     * drifted once.
     *
     * Bound per render because the markup is replaced each time a report opens,
     * and `serviceName` is what the buttons need — it is a parameter rather than
     * read back out of the heading, which would break the day the heading is
     * reworded.
     */
    function initServiceExportButtons(serviceName) {
        const EXPORTS = {
            excel: { url: CONFIG.EXPORT_SERVICE_EXCEL, ext: 'xlsx' },
            csv:   { url: CONFIG.EXPORT_SERVICE_CSV,   ext: 'csv'  },
            pdf:   { url: CONFIG.EXPORT_SERVICE_PDF,   ext: 'pdf'  }
        };

        $('.btn-export-service').off('click').on('click', async function () {
            const $btn = $(this);
            const chosen = EXPORTS[$btn.data('type')];

            if (!chosen) {
                return;
            }

            const originalHtml = $btn.html();
            $btn.html('<span class="spinner-border spinner-border-sm"></span>').prop('disabled', true);

            try {
                const response = await fetch(chosen.url, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${TOKEN}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        moduleCode: CONFIG.MODULE_CODE,
                        service: serviceName
                    })
                });

                if (response.status === 401) { handleUnauthorized(); return; }

                // Same reason as the on-screen report: a firm that is not
                // subscribed should be told which service, not handed "Server
                // error" to puzzle over.
                if (response.status === 403) {
                    const errData = await response.json().catch(() => ({}));
                    const blocked = (errData.deniedServices || [serviceName]).join(', ');
                    showInlineError(`${errData.error || 'You are not subscribed to this service.'}${blocked ? ' (' + blocked + ')' : ''}`);
                    return;
                }

                if (!response.ok) throw new Error('Export failed on server side.');

                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);

                // The service name goes in the filename so a folder of these stays
                // readable; anything a filesystem objects to becomes an underscore.
                const safeName = String(serviceName).replace(/[\\/:*?"<>|]+/g, '_').trim();

                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = `${safeName} (${CONFIG.MODULE_CODE.toUpperCase()}) ${new Date().toISOString().slice(0, 10)}.${chosen.ext}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(downloadUrl);
            } catch (error) {
                console.error('Service export error:', error);
                showInlineError('Could not export the report. Please try again.');
            } finally {
                $btn.html(originalHtml).prop('disabled', false);
            }
        });
    }

    // 2. RENDER SURVEY TREE STRUCTURE
    function renderSurveyTree(data) {
        let html = '';

        function buildTree(items, level = 0) {
            if (!items || !Array.isArray(items)) return '';

            return items.map((node, idx) => {
                if (node.type === 'group') {
                    const isTopLevel = level === 0;
                    const containerClass = isTopLevel ? 'survey-group mb-3' : 'sub-group mt-2';
                    const headerClass = isTopLevel ? 'group-header' : 'sub-group-header';
                    const titleClass = isTopLevel
                        ? 'group-title fw-bold text-navy text-uppercase'
                        : 'sub-group-title fw-bold text-navy';

                    const cleanedName = node.name ? node.name.replace(/\s+\d+$/, '') : '';
                    const hasChildren = node.items && Array.isArray(node.items) && node.items.length > 0;

                    // FIX:
                    // A group with no children is still drawn as an accordion,
                    // but with one q-check inside it, so that Next can become
                    // active
                    const innerContent = hasChildren
                        ? buildTree(node.items, level + 1)
                        : `
        <div class="d-flex gap-2 mb-2 align-items-start ms-2">
            <input type="checkbox" class="form-check-input q-check mt-1" value="${cleanedName}">
            <label class="q-text cursor-pointer">${cleanedName}</label>
        </div>`;

                    return `
        <div class="${containerClass}">
            <div class="${headerClass} d-flex align-items-center gap-2 py-2 cursor-pointer">
                <span class="arrow-icon">
                    <svg class="chevron" width="16" height="10" viewBox="0 0 16 10" fill="none">
                        <path d="M1 1L8 8L15 1" stroke="#294661" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </span>
                <input type="checkbox" class="form-check-input group-checkbox">
                <span class="${titleClass}">${cleanedName}</span>
            </div>
            <div class="group-content ms-4" style="display:none;">
                ${innerContent}
            </div>
        </div>`;
                } else if (node.type === 'entry') {
                    return `
        <div class="d-flex gap-2 mb-2 align-items-start ms-2">
            <input type="checkbox" class="form-check-input q-check mt-1" value="${node.name}">
            <label class="q-text cursor-pointer">${node.name}</label>
        </div>`;
                }

                return '';
            }).join('');
        }

        html = buildTree(data.items);

        const $accordion = $(CONFIG.CONTAINERS.ACCORDION);
        $accordion.html(html || '<p class="text-center">No questions found.</p>');

        // 1. CASCADING CHECKBOX SELECTION
        $accordion.off('change', '.group-checkbox').on('change', '.group-checkbox', function(e) {
            e.stopPropagation();

            const isChecked = this.checked;
            const $groupContainer = $(this).closest('.survey-group, .sub-group');
            const $content = $groupContainer.children('.group-content');

            $content.find('input[type="checkbox"]')
                .prop('checked', isChecked)
                .trigger('change');

            if (isChecked) {
                $content.slideDown(200);
                $groupContainer.addClass('active');
            }

            if (typeof updateNextButtonState === 'function') {
                updateNextButtonState();
            }
        });

        // 2. A SINGLE QUESTION CHECKBOX CHANGES
        $accordion.off('change', '.q-check').on('change', '.q-check', function(e) {
            e.stopPropagation();
            if (typeof updateNextButtonState === 'function') updateNextButtonState();
        });

        // 3. ACCORDION EXPAND ANIMATION
        $accordion.off('click', '.group-header, .sub-group-header').on('click', '.group-header, .sub-group-header', function(e) {
            if ($(e.target).is('input[type="checkbox"]')) return;
            $(this).next('.group-content').slideToggle(200);
        });

        if (typeof updateNextButtonState === 'function') updateNextButtonState();


        $accordion.off('click', '.q-text').on('click', '.q-text', function(e) {
            e.preventDefault();

            const $check = $(this).siblings('.q-check');

            $check
                .prop('checked', !$check.prop('checked'))
                .trigger('change');
        });
    }

    // Helper: wrap bare URLs in plain text with <a> tags for the comparison view
    function linkifyTextUrls(text) {
        return text.replace(
            /(https?:\/\/[^\s<>"')]+)/g,
            '<a href="$1" target="_blank" rel="noopener noreferrer" style="word-break:break-all;overflow-wrap:anywhere;">$1</a>'
        );
    }

    // 3. GENERATE COMPARISON REPORT
    $(CONFIG.CONTAINERS.NEXT_BTN).off('click').on('click', async function() {
        const selectedQuestions = $('.q-check:checked').map(function() { return $(this).val(); }).get();
        const selectedServices = $('.service-check:checked:not(:disabled)').map(function() { return $(this).val(); }).get();

        if (!selectedServices.length || !selectedQuestions.length) {
            showInlineError("Please select at least one service and one question.");
            return;
        }

        const $btn = $(this);
        const originalText = $btn.text();
        $btn.html('<span class="spinner-border spinner-border-sm me-2"></span>Generating...').prop('disabled', true);

        try {
            const response = await fetch(`${CONFIG.API_BASE}/generateReport`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${TOKEN}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "moduleCode": CONFIG.MODULE_CODE,
                    "services": selectedServices,
                    "questions": selectedQuestions
                })
            });

            if (response.status === 401) { handleUnauthorized(); return; }
            const result = await response.json();
            if (!response.ok) {
                // HOTFIX: entitlement rejection — name the services that were blocked.
                if (response.status === 403 && result.code === 'SERVICE_NOT_ENTITLED') {
                    const blocked = (result.deniedServices || []).join(', ');
                    throw new Error(`${result.error || 'You are not subscribed to some of the selected services.'}${blocked ? ' (' + blocked + ')' : ''} Please contact your administrator.`);
                }
                throw new Error(serverErrorText(result, response.status));
            }

            renderReportResults(result, selectedServices, selectedQuestions);
        } catch (error) {
            showInlineError(error.message);
        } finally {
            $btn.text(originalText).prop('disabled', false);
        }
    });


// 4. RENDER COMPARISON RESULTS (FIXED READ-MORE SELECTORS & LAYOUT)
    // 4. RENDER COMPARISON RESULTS WITH EXPORT BUTTONS
// 4. RENDER COMPARISON RESULTS WITH EXPORT BUTTONS (THE FULL MATRIX, NOTHING HIDDEN)
    function renderReportResults(apiResponse, serviceList, questionList) {
        const reportData = apiResponse.result || [];
        const allLinks = apiResponse.links || [];

        let reportItemsHtml = '';
        // Nothing is hidden any more, so the row count always equals the question list
        let visibleRowsCount = questionList.length;

        questionList.forEach((questionName, qIdx) => {

            // Collect the answers for EVERY selected service for this question
            const serviceAnswersHtml = serviceList.map((serviceName, sIdx) => {
                let cellText = reportData[sIdx]?.htmlAnswers?.[qIdx]
                    ?? reportData[sIdx]?.answers?.[qIdx]
                    ?? null;

                const linkObj = allLinks.find(l =>
                    Number(l.questionIndex) === qIdx &&
                    Number(l.serviceIndex) === sIdx
                );

                const linksArray = linkObj ? (linkObj.links || []) : [];
                const linksHtml = typeof renderLinksHtml === 'function' ? renderLinksHtml(linksArray) : '';

                // Is the text worth printing: null and a literal N/A are not
                const isValidText = cellText && cellText !== 'null' && cellText !== "" && String(cellText).toUpperCase() !== "N/A" && String(cellText).toUpperCase() !== "NA";
                const hasLinks = linksArray.length > 0;

                let fullServiceName = serviceName;
                if (linkObj && linkObj.serviceName) {
                    fullServiceName = linkObj.serviceName;
                } else if (apiResponse && apiResponse.items && apiResponse.items[sIdx]) {
                    const group = apiResponse.items[sIdx];
                    if (group.items && group.items[0] && group.items[0].name) {
                        fullServiceName = group.items[0].name;
                    } else if (group.name) {
                        fullServiceName = group.name;
                    }
                }

                const serviceHeaderHtml = `<div class="service-title fw-bold text-secondary mb-1" style="font-size: 0.95rem; color: #6c757d;">${fullServiceName}:</div>`;

                // The answer is kept whole.
                //
                // It used to be cut at the first "Note:", on the assumption that
                // whatever followed was an editor's remark and could be tucked
                // away. FIA answers carry footnotes in the middle of the text —
                // "*Note: the recognition under EMIR is temporary" — so the cut
                // landed inside the answer and hid the rest of it, several
                // paragraphs of substance, behind a Show more labelled as a note.
                //
                // Nothing in this response marks a notes section: /generateReport
                // runs the older generator, and the "Notes:" heading only exists in
                // generateReportV2, which serves the PDF and Excel routes. There is
                // no note to separate, so the answer is clamped as a whole instead.
                const mainText = isValidText ? String(cellText) : '';

                // Keep the line breaks, without filtering or dropping any line
                let formattedMainText = mainText.trim() !== ''
                    ? (/<[a-z]/i.test(mainText)
                        ? normalizeReportHtml(mainText)                         // already HTML — repair tables, URLs already <a> from backend
                        : linkifyTextUrls(mainText).replace(/\n/g, '<br>'))    // plain text — linkify bare URLs first
                    : '';

                // No answer, and no attachments standing in for one. Says "N/A" in
                // plain text, matching the full report: the two views read the same
                // data, and wording the same state differently in each invites the
                // reader to think they mean different things.
                //
                // It used to read "— No data available" in grey italic, which looks
                // like a remark from the platform. N/A is the survey's own answer,
                // and FIA asked for that word on 09.10.2026.
                if (formattedMainText === '' && !hasLinks) {
                    formattedMainText = 'N/A';
                }

                return `
<div class="service-answer-block mb-3 p-2 rounded" style="background-color: #fcfcfc; border: 1px solid #f1f1f1;">
    ${serviceHeaderHtml}
    
    <div class="main-text-wrapper answer-wrapper position-relative mb-2">
        <div class="answer-text text-dark" style="font-size: 0.95rem; line-height: 1.5; max-height: ${ANSWER_CLAMP_PX}px; overflow: hidden; transition: max-height 0.25s ease;">
            ${formattedMainText}
        </div>
        <div class="read-more-overlay" style="position: absolute; bottom: 0; left: 0; width: 100%; height: 45px; background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.9) 40%, rgba(255, 255, 255, 1) 100%); display: none; pointer-events: none;"></div>
        <a href="javascript:void(0);" class="read-more-btn text-decoration-none small fw-bold mt-1" data-expanded="false" style="color: #00a3c4; display: none; position: relative; z-index: 2;">Show more</a>
    </div>

    ${hasLinks ? `
        <div class="mt-2 note-section">
            <a href="javascript:void(0);" class="toggle-note-btn text-decoration-none small fw-bold d-inline-flex align-items-center" data-expanded="false" style="color: #00a3c4;">
                <span class="btn-text">Show links</span>
                <svg class="ms-1 note-chevron" width="10" height="6" viewBox="0 0 16 10" fill="none" style="transform: rotate(0deg); transition: transform 0.2s;">
                    <path d="M1 1L8 8L15 1" stroke="#00a3c4" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </a>
            <div class="note-container-block mt-2" style="display: none;">
                <hr class="my-2" style="border: 0; border-top: 1px solid #dee2e6; opacity: 0.8;">
                <div class="note-content pb-2 text-muted" style="font-size: 0.875rem; line-height: 1.4;">
                    ${linksHtml}
                </div>
            </div>
        </div>
    ` : ''}
</div>`;
            }).join('');

            // The question row, with a block per service inside it - including the empty ones
            reportItemsHtml += `
<div class="py-4 border-bottom question-report-row" style="border-bottom: 1px solid #eaedf1 !important;">
    <div class="row">
        <div class="col-md-4 mb-2 mb-md-0">
            <div class="fw-bold text-navy" style="font-size: 0.95rem; padding-right: 15px; color: #294661;">
                ${questionName}
            </div>
        </div>
        <div class="col-md-8">
            ${serviceAnswersHtml}
        </div>
    </div>
</div>`;
        });

        // Export buttons in the header, when there is anything to export
        const exportButtonsHtml = visibleRowsCount > 0 ? `
    <div class="d-flex gap-2 mt-2 mt-md-0">
        <button type="button" class="btn btn-sm btn-outline-success d-flex align-items-center gap-1 btn-export-report" data-type="excel">
            <img src="https://cdn-icons-png.flaticon.com/512/888/888850.png" width="14" height="14" alt="excel">
            <span>Export Excel</span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 btn-export-report" data-type="csv">
            <img src="https://cdn-icons-png.flaticon.com/512/1091/1091916.png" width="14" height="14" alt="csv">
            <span>Export CSV</span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger d-flex align-items-center gap-1 btn-export-report" data-type="pdf">
            ${PDF_ICON_SVG}
            <span>Export PDF</span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 btn-share-report">
            <span>Copy link</span>
        </button>
    </div>
` : '';

        const finalHtml = `
<style>
    .report-container .service-answer-block a {
        word-break: break-all;
        overflow-wrap: anywhere;
    }
    .report-container .service-answer-block .text-dark,
    .report-container .service-answer-block p {
        overflow-wrap: anywhere;
        word-break: break-word;
    }
    /* Style tables embedded inside an answer block so they read as tables (they carry no class). */
    .report-container .service-answer-block table { border-collapse: collapse; width: 100%; margin: 0.4em 0; }
    .report-container .service-answer-block table td,
    .report-container .service-answer-block table th { border: 1px solid #c5ccd3; padding: 6px 10px; vertical-align: top; text-align: left; }
    .report-container .service-answer-block table th { background: #f3f5f7; font-weight: 600; }
    .report-container .service-answer-block table tr:nth-child(even) td { background: #fafbfc; }
    /* Document links: one chip per line (never sit two side by side). */
    .report-container .service-answer-block > div:has(> a.btn-outline-light) {
        display: flex; flex-direction: column; align-items: flex-start; gap: 0.5rem;
    }
    .report-container a.btn-outline-light { display: inline-flex; max-width: 100%; white-space: normal; text-align: left; }
</style>
<div class="report-container mt-5 p-4 border rounded bg-white shadow-sm">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 border-bottom pb-3 gap-3">
        <div>
            <h3 class="text-navy mb-1 fw-bold" style="color: #294661;">Comparison Report</h3>
            <small class="text-muted">Generated for ${serviceList.length} service(s)</small>
        </div>
        <div class="d-flex align-items-center gap-3">
            ${exportButtonsHtml}
            <button type="button" class="btn-close" onclick="$('.report-container').remove()"></button>
        </div>
    </div>
    
    <div class="report-list-wrapper">
        ${visibleRowsCount > 0 ? reportItemsHtml : `<div class="text-center p-5 text-muted">No matching data found for selected criteria.</div>`}
    </div>
</div>`;

        $('.report-container').remove();
        $(CONFIG.CONTAINERS.ACCORDION).after(finalHtml);

        // Read More and the links
        if (typeof initReadMoreTriggers === 'function') {
            initReadMoreTriggers();
        } else {
            // In case the function is named slightly differently, initialise here:
            initFallbackReadMore();
        }

        // EXPORT BUTTON CLICK
        $('.btn-export-report').off('click').on('click', async function() {
            const exportType = $(this).data('type');
            const $btn = $(this);
            const originalHtml = $btn.html();

            $btn.html('<span class="spinner-border spinner-border-sm"></span>').prop('disabled', true);

            // Three formats now, so a table rather than a chain of ternaries: the
            // next one to be added is then one line, in one place, instead of two
            // expressions that have to be kept in step.
            const EXPORTS = {
                excel: { url: CONFIG.EXPORT_EXCEL, ext: 'xlsx' },
                csv:   { url: CONFIG.EXPORT_CSV,   ext: 'csv'  },
                pdf:   { url: CONFIG.EXPORT_PDF,   ext: 'pdf'  }
            };

            const chosen = EXPORTS[exportType] || EXPORTS.csv;
            const apiUrl = chosen.url;
            const fileExtension = chosen.ext;

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${TOKEN}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "moduleCode": CONFIG.MODULE_CODE,
                        "services": serviceList,
                        "questions": questionList
                    })
                });

                if (response.status === 401) { handleUnauthorized(); return; }
                if (response.status === 403) {
                    const errData = await response.json().catch(() => ({}));
                    const blocked = (errData.deniedServices || []).join(', ');
                    showInlineError(`${errData.error || 'You are not subscribed to some of the selected services.'}${blocked ? ' (' + blocked + ')' : ''}`);
                    return;
                }
                if (!response.ok) throw new Error('Export failed on server side.');

                const blob = await response.blob();

                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = `Comparison_Report_${CONFIG.MODULE_CODE}_${new Date().toISOString().slice(0,10)}.${fileExtension}`;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(downloadUrl);

            } catch (error) {
                console.error("Export error:", error);
                alert("Could not export file. Please try again.");
            } finally {
                $btn.html(originalHtml).prop('disabled', false);
            }
        });

        // SHAREABLE LINK: store the current selection server-side and copy a URL
        // that reopens this same report. The link carries only an id — opening it
        // re-runs the report against live data and re-checks the opener's own
        // entitlements, so it never grants access the recipient doesn't have.
        $('.btn-share-report').off('click').on('click', async function() {
            const $btn = $(this);
            const originalHtml = $btn.html();

            $btn.html('<span class="spinner-border spinner-border-sm"></span>').prop('disabled', true);

            try {
                const response = await fetch(`${CONFIG.API_BASE}/generateReport/link`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${TOKEN}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "moduleCode": CONFIG.MODULE_CODE,
                        "services": serviceList,
                        "questions": questionList
                    })
                });

                if (response.status === 401) { handleUnauthorized(); return; }

                const data = await response.json().catch(() => ({}));

                if (response.status === 403) {
                    const blocked = (data.deniedServices || []).join(', ');
                    showInlineError(`${data.error || 'You are not subscribed to some of the selected services.'}${blocked ? ' (' + blocked + ')' : ''}`);
                    return;
                }
                if (!response.ok || !data.linkId) throw new Error('Could not create the link.');

                const shareUrl = `${window.location.origin}${window.location.pathname}?report=${encodeURIComponent(data.linkId)}`;
                const copied = await copyTextToClipboard(shareUrl);

                if (copied) {
                    $btn.html('<span>Link copied</span>');
                    setTimeout(() => $btn.html(originalHtml).prop('disabled', false), 2000);
                    return;
                }

                // Clipboard blocked (permissions, older browser): show the URL so
                // it can still be copied by hand rather than failing silently.
                window.prompt('Copy this link:', shareUrl);
            } catch (error) {
                console.error("Share link error:", error);
                showInlineError("Could not create a shareable link. Please try again.");
            } finally {
                if (!$btn.text().includes('copied')) {
                    $btn.html(originalHtml).prop('disabled', false);
                }
            }
        });

        $('html, body').animate({
            scrollTop: $(".report-container").offset().top - 50
        }, 500);
    }

    // Clipboard write with a fallback for contexts where the async API is
    // unavailable or blocked. Returns true only if the text actually landed.
    async function copyTextToClipboard(text) {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                return true;
            }
        } catch (e) {
            // fall through to the textarea approach
        }

        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.top = '-1000px';
            document.body.appendChild(textarea);
            textarea.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(textarea);
            return ok;
        } catch (e) {
            return false;
        }
    }

    // Fallback for the note and link triggers, when initReadMoreTriggers does not cover them
    function initFallbackReadMore() {
        $('.answer-text').each(function() {
            if ($(this)[0].scrollHeight > ANSWER_CLAMP_PX) {
                $(this).next('.read-more-overlay').show();
                $(this).siblings('.read-more-btn').show();
            }
        });

        $('.read-more-btn').off('click').on('click', function() {
            const $btn = $(this);
            const $text = $btn.siblings('.answer-text');
            const $overlay = $btn.siblings('.read-more-overlay');
            const isExpanded = $btn.attr('data-expanded') === 'true';

            if (isExpanded) {
                $text.css('max-height', ANSWER_CLAMP_PX + 'px');
                $overlay.fadeIn(150);
                $btn.text('Show more').attr('data-expanded', 'false');
            } else {
                $text.css('max-height', $text[0].scrollHeight + 'px');
                $overlay.fadeOut(150);
                $btn.text('Show less').attr('data-expanded', 'true');
            }
        });

        $('.toggle-note-btn').off('click').on('click', function() {
            const $btn = $(this);
            const $container = $btn.next('.note-container-block');
            const $chevron = $btn.find('.note-chevron');
            const isExpanded = $btn.attr('data-expanded') === 'true';

            $container.slideToggle(200);
            if (isExpanded) {
                $chevron.css('transform', 'rotate(0deg)');
                $btn.find('.btn-text').text('Show links');
                $btn.attr('data-expanded', 'false');
            } else {
                $chevron.css('transform', 'rotate(180deg)');
                $btn.find('.btn-text').text('Hide links');
                $btn.attr('data-expanded', 'true');
            }
        });
    }



// --- MEASURE THE TEXT HEIGHT (FINDING THE BUTTON DIRECTLY) ---
    function initReadMoreTriggers() {
        $('.report-container .answer-text').each(function() {
            const $textBlock = $(this);
            // Is the real content taller than the threshold
            if ($textBlock[0].scrollHeight > ANSWER_CLAMP_PX) {
                // Show the overlay and the button through jQuery .show(), to avoid fighting d-none
                $textBlock.siblings('.read-more-overlay').show();
                $textBlock.siblings('.read-more-btn').show();
            }
        });
    }

// --- "SHOW MORE / SHOW LESS" CLICK ---
    $(document).off('click', '.read-more-btn').on('click', '.read-more-btn', function(e) {
        e.preventDefault();
        const $btn = $(this);
        const $text = $btn.siblings('.answer-text');
        const $overlay = $btn.siblings('.read-more-overlay');
        const isExpanded = $btn.attr('data-expanded') === 'true';

        if (isExpanded) {
            $text.css('max-height', ANSWER_CLAMP_PX + 'px');
            $overlay.show();
            $btn.attr('data-expanded', 'false').text('Show more');
        } else {
            $text.css('max-height', $text[0].scrollHeight + 'px');
            $overlay.hide();
            $btn.attr('data-expanded', 'true').text('Show less');
        }
    });

// --- "SHOW NOTE" CLICK ---
    $(document).off('click', '.toggle-note-btn').on('click', '.toggle-note-btn', function(e) {
        e.preventDefault();
        const $btn = $(this);
        const $container = $btn.next('.note-container-block');
        const $chevron = $btn.find('.note-chevron');
        const isExpanded = $btn.attr('data-expanded') === 'true';

        $container.slideToggle(200);

        if (isExpanded) {
            $btn.attr('data-expanded', 'false').find('span').text('Show note');
            $chevron.css('transform', 'rotate(0deg)');
        } else {
            $btn.attr('data-expanded', 'true').find('span').text('Hide note');
            $chevron.css('transform', 'rotate(180deg)');
        }
    });



    // 5. EVENT DELEGATION
    $(CONFIG.CONTAINERS.ACCORDION).on('click', '.group-header, .sub-group-header', function(e) {
        if ($(e.target).is('input')) return;
        $(this).next().slideToggle(250).parent().toggleClass('active');
    });

    $(CONFIG.CONTAINERS.ACCORDION).on('change', 'input[type="checkbox"]', function() {
        const isChecked = this.checked;
        const $section = $(this).closest('.group-header, .sub-group-header').next();
        $section.find('input[type="checkbox"]').prop('checked', isChecked);
        if (isChecked) $section.slideDown(250).parent().addClass('active');
        updateNextButtonState();
    });

    function updateNextButtonState() {
        const qCount = $('.q-check:checked').length;
        const sCount = $('.service-check:checked:not(:disabled)').length;
        $(CONFIG.CONTAINERS.NEXT_BTN).prop('disabled', !(qCount && sCount));

        const $selectAllBtn = $('#select-all-q');
        if ($selectAllBtn.length) {
            const allChecked = $('.q-check:not(:checked)').length === 0 && $('.q-check').length > 0;
            $selectAllBtn.text(allChecked ? 'Deselect all' : 'Select all');
        }
    }

    initSurveyPage();
});



// Webinars Infinite Scroll Ajax
;(function($) {
    $(document).ready(function() {
        let canLoad = true;
        const container = $('.webinar-posts-container');

        if (container.length === 0 || parseInt(container.data('max-pages')) <= 1) {
            return;
        }

        $(window).on('scroll', function() {
            if ($(window).scrollTop() + $(window).height() > container.offset().top + container.height() - 200 && canLoad) {

                let currentPage = parseInt(container.data('page'));
                let maxPages = parseInt(container.data('max-pages'));
                let compare = container.data('compare');

                if (currentPage < maxPages) {
                    canLoad = false;
                    $('#webinar-loader').show();

                    $.ajax({
                        url: '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        data: {
                            action: 'load_more_webinars',
                            page: currentPage + 1,
                            compare: compare
                        },
                        success: function(res) {
                            if (res && res.trim() !== '') {
                                container.append(res);
                                container.data('page', currentPage + 1);
                                canLoad = true;
                                $('#webinar-loader').hide();


                            } else {
                                $('#webinar-loader').hide();
                                canLoad = false;
                            }
                        },
                        error: function() {
                            $('#webinar-loader').hide();
                            canLoad = true;
                        }
                    });
                }
            }
        });
    });

    // Menu Links

    if ($(window).width() > 992) {
        $('.dropdown-toggle').on('click', function() {
            var url = $(this).attr('href');
            if (url && url !== '#') {
                window.location.href = url;
            }
        });
    }
})(jQuery);







// Header PopUp

document.addEventListener('DOMContentLoaded', function() {
    const btn = document.getElementById('notification-btn');
    const popup = document.getElementById('notification-popup');
    const container = document.getElementById('notification-items-container');
    const badge = document.getElementById('notif-count-badge');
    let currentSection = 'unread';

    const BASE_URL = '/api/ai/notifications';

    const getHeaders = () => {
        const token = localStorage.getItem('authToken');

        if (!token) {
            return null;
        }

        return {
            'Authorization': `Bearer ${token.trim()}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
    };
    async function updateUnreadCount() {
        if (!badge) return;
        const headers = getHeaders();
        if (!headers) return;

        try {
            const res = await fetch(`${BASE_URL}/getUnreadNotificationCount`, { headers });

            if (!res.ok) {
                const errorText = await res.text();
                console.error(`Server Error ${res.status}:`, errorText);
                return;
            }

            const data = await res.json();
            const count = data.result?.count ?? data.count ?? 0;

            if (count > 0) {
                badge.innerText = count > 99 ? '99+' : count;
                badge.style.display = 'block';
            } else {
                badge.style.display = 'none';
            }
        } catch (err) {
            console.error('Network or Parsing error:', err);
        }
    }
    async function loadNotifications(section = 'unread') {
        if (!container) return;
        container.innerHTML = '<div class="p-3 text-center">Loading...</div>';

        const headers = getHeaders();
        if (!headers) return;

        try {
            const url = `${BASE_URL}/getNotifications?section=${section}&limit=20`;
            const res = await fetch(url, { method: 'GET', headers });

            if (!res.ok) throw new Error(`: ${res.status}`);

            const data = await res.json();
            const notifications = data.result?.notifications ?? data.notifications ?? [];
            renderNotifications(notifications, section);

        } catch (err) {
            container.innerHTML = `<div class="p-4 text-center text-danger">Error: ${err.message}</div>`;
        }
    }



    function renderNotifications(notifications, section) {
        if (!notifications || notifications.length === 0) {
            container.innerHTML = `<div class="p-4 text-center" style="color: #666;">No ${section} notifications</div>`;
            return;
        }

        const viewDocBaseUrl = `${window.location.origin}/view-document/`;

        container.innerHTML = notifications.map(n => {
            const docId = n.documentId || n.document_uuid || '';
            const verId = n.versionId || n.version_uuid || '';
            const docTitle = n.documentTitle || n.title || n.documentName || 'View Document';

            let href = n.link;
            if (!href && docId) {
                href = `${viewDocBaseUrl}?doc=${encodeURIComponent(docId)}&ver=${encodeURIComponent(verId)}`;
            }

            return `
            <div class="notification-item ${section === 'unread' ? 'is-unread' : ''}" data-id="${n.id}">
                <div class="notification-content">
                    <p class="notif-title" style="margin:0; font-weight: 500;">${escapeHtml(docTitle)}</p>
                    <a href="${href || '#'}" class="notif-link" target="_blank" style="color: #0056b3; font-size: 0.9em;">
                        View Document
                    </a>
                </div>
                <div class="notification-meta" style="display: flex; align-items: center; gap: 10px;">
                    <span class="notif-time" style="color: #888; font-size: 0.8em;">${formatNotifDate(n.createdAt)}</span>
                    ${section === 'unread' ? '<span class="unread-dot" style="width: 8px; height: 8px; background: blue; border-radius: 50%;"></span>' : ''}
                </div>
            </div>
        `;
        }).join('');

        if (section === 'unread' && notifications.length > 0 && !notifications[0].id.toString().includes('test')) {
            const ids = notifications.map(n => n.id);
            setTimeout(() => markAsRead(ids), 3000);
        }
    }

    async function markAsRead(notificationIds) {
        const headers = getHeaders();
        if (!headers) return;
        try {
            await fetch(`${BASE_URL}/markNotificationsAsRead`, {
                method: 'POST',
                headers,
                body: JSON.stringify({ notificationIds: notificationIds })
            });
            updateUnreadCount();
        } catch (err) {
            console.error('Mark read error:', err);
        }
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text || '';
        return div.innerHTML;
    }

    function formatNotifDate(dateStr) {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const now = new Date();
        if (d.toDateString() === now.toDateString()) {
            return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        }
        return d.toLocaleDateString([], { day: '2-digit', month: 'short' });
    }

    updateUnreadCount();

    if (btn) {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (popup.classList.toggle('active')) loadNotifications(currentSection);
        });
    }

    document.querySelectorAll('.tab-btn').forEach(tab => {
        tab.addEventListener('click', function() {
            document.querySelectorAll('.tab-btn').forEach(t => t.classList.remove('active'));
            this.classList.add('active');
            currentSection = this.dataset.tab;
            loadNotifications(currentSection);
        });
    });
});

document.addEventListener('mousedown', function(event) {
    const popup = document.getElementById('notification-popup');
    const btn = document.getElementById('notification-btn');

    if (!popup || !btn) return;

    if (popup.classList.contains('active')) {
        if (!popup.contains(event.target) && !btn.contains(event.target)) {
            popup.classList.remove('active');
        }
    }
});


// Menu Fix
//
// This used to run at every width and force window.location on any click of a
// parent menu link that had a real URL. On a phone that is the same element a
// visitor taps to open the submenu, so the submenu could never be opened for
// "CCP Risk Review" and the rest - the tap always left the page. The desktop
// half of this behaviour already exists above, guarded by a width check, so
// this copy is now guarded the same way instead of applying everywhere.
document.addEventListener('DOMContentLoaded', function() {
    if (!window.matchMedia('(min-width: 992px)').matches) {
        return;
    }

    const dropdownLinks = document.querySelectorAll('.navbar-nav .dropdown-toggle');

    dropdownLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');

            if (href && href !== '#' && href !== 'javascript:void(0);') {
                window.location.href = href;
            }
        });
    });
});


// Mobile menu: a separate arrow control, and a page that stays put
//
// Two problems the bug report describes, both of them structural rather than
// cosmetic:
//
//   1. A top-level item with children is a single <a> that carries both the
//      href and Bootstrap's data-toggle. One tap cannot mean both "go to the
//      page" and "open the submenu", and the handler above resolved it in
//      favour of the page. The arrow is now its own button next to the link:
//      the arrow opens the submenu, the label still goes to the page. Items
//      with href="#" have no page to go to, so there the label toggles too.
//
//   2. The page behind the open sheet kept scrolling. The scroll position is
//      remembered, the body is pinned, and the position is restored on close -
//      pinning alone would otherwise send the visitor back to the top.
(function($) {
    var MOBILE = '(max-width: 991px)';
    var CARET = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path opacity="0.8" d="M10.7 0.700195L5.7 5.7002L0.699997 0.700195" stroke="black" stroke-width="1.4" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function isMobile() {
        return window.matchMedia(MOBILE).matches;
    }

    $(function() {
        var $panel = $('#navbarNavDropdown');
        if ($panel.length === 0) {
            return;
        }

        // Build the arrow controls once, for every width. They are only visible
        // under 992px (see .submenu-toggle in main-style.scss), so a visitor who
        // resizes the window does not end up without them.
        $panel.find('.navbar-nav > .nav-item.dropdown').each(function() {
            var $item = $(this);
            var $link = $item.children('.dropdown-toggle').first();

            if ($link.length === 0 || $item.children('.submenu-toggle').length > 0) {
                return;
            }

            var label = ($link.text() || '').trim();
            var $button = $('<button type="button" class="submenu-toggle" aria-expanded="false"></button>')
                .attr('aria-label', label ? 'Show ' + label + ' submenu' : 'Show submenu')
                .html(CARET);

            $link.after($button);
        });

        $panel.on('click', '.submenu-toggle', function(event) {
            event.preventDefault();
            event.stopPropagation();

            var $item = $(this).closest('.nav-item');
            var isOpen = $item.hasClass('show');

            // One submenu at a time, matching how the menu behaves on desktop.
            $panel.find('.navbar-nav > .nav-item.show').not($item).each(function() {
                $(this).removeClass('show')
                    .children('.dropdown-menu').removeClass('show').end()
                    .children('.submenu-toggle').attr('aria-expanded', 'false').end()
                    .children('.dropdown-toggle').attr('aria-expanded', 'false');
            });

            $item.toggleClass('show', !isOpen)
                .children('.dropdown-menu').toggleClass('show', !isOpen);
            $item.children('.dropdown-toggle').attr('aria-expanded', String(!isOpen));
            $(this).attr('aria-expanded', String(!isOpen));
        });

        // On a phone a parent link that has a real page should go there, not
        // toggle. Bootstrap's own data-api would toggle it, so it is stopped
        // here; href="#" items keep toggling, since there is nowhere to go.
        $panel.on('click', '.navbar-nav > .nav-item.dropdown > .dropdown-toggle', function(event) {
            if (!isMobile()) {
                return;
            }

            var href = $(this).attr('href');
            if (href && href !== '#' && href !== 'javascript:void(0);') {
                // Bootstrap's dropdown data-api cancels the click on anything
                // carrying data-toggle="dropdown", so letting the default run
                // would go nowhere - which is why the old code assigned
                // window.location in the first place. The difference now is
                // that this only fires for the label; the arrow beside it has
                // its own handler and never gets here.
                event.preventDefault();
                event.stopPropagation();
                window.location.href = href;
                return;
            }

            // Bootstrap's data-api would toggle this item as well, which would
            // undo the toggle the button below performs.
            event.preventDefault();
            event.stopPropagation();
            $(this).siblings('.submenu-toggle').trigger('click');
        });

        var scrollY = 0;

        $panel.on('show.bs.collapse', function() {
            scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
            document.body.style.top = (-scrollY) + 'px';
            document.body.classList.add('mobile-menu-open');

            // Tells the stylesheet this .collapsing is an opening one, so the
            // sheet fades in while Bootstrap runs its own animation rather than
            // waiting for it to finish.
            $panel.addClass('menu-opening');
        });

        $panel.on('shown.bs.collapse', function() {
            $panel.removeClass('menu-opening');
        });

        $panel.on('hidden.bs.collapse', function() {
            document.body.classList.remove('mobile-menu-open');
            document.body.style.top = '';
            window.scrollTo(0, scrollY);

            // Leave the sheet closed rather than reopening on the submenu that
            // happened to be open last time.
            $panel.find('.nav-item.show').removeClass('show')
                .children('.dropdown-menu').removeClass('show');
            $panel.find('.submenu-toggle, .dropdown-toggle').attr('aria-expanded', 'false');
        });
    });
})(jQuery);


jQuery(document).ready(function($) {
    $('.dropdown-menu a.dropdown-item').on('click', function(e) {
        var href = $(this).attr('href');
        if (href && href !== '#') {
            window.location.href = href;
        }
    });
});



jQuery(document).ready(function($) {

    $('.region-toggle').on('change', function() {
        var regionSlug = $(this).data('region-target');
        var isChecked = $(this).is(':checked');

        $('li[data-region-group="' + regionSlug + '"] .jurisdiction-filter').each(function() {
            $(this).prop('checked', isChecked);
            $(this).trigger('change');
        });
    });

    // A region is ticked when every country under it is ticked. This used to be
    // computed only from a country's change event, so a page that arrived with
    // countries already selected - which is what show_by_default does - painted
    // a cleared region over ticked children and stayed that way until something
    // was clicked.
    function syncRegionFromCountries(regionSlug) {
        var $countries = $('li[data-region-group="' + regionSlug + '"] .jurisdiction-filter');
        var allChecked = $countries.length > 0 && $countries.filter(':checked').length === $countries.length;

        $('.region-toggle[data-region-target="' + regionSlug + '"]').prop('checked', allChecked);
    }

    $('.jurisdiction-filter').on('change', function() {
        syncRegionFromCountries($(this).closest('li').data('region-group'));
    });

    // Bring the regions in line with whatever the markup arrived with, so the
    // two halves of the filter agree before the visitor touches anything.
    $('.region-toggle').each(function() {
        syncRegionFromCountries($(this).data('region-target'));
    });
});





(function($) {
    "use strict";

    $(document).ready(function() {
        if ($('body').hasClass('page-id-815')) {
            $('.ccp-risk-page').insertBefore('footer.site-footer');
            $('.jurisdictional-section').insertAfter('.legal-content');
        }

        if ($('body').hasClass('page-id-1125')) {
            $('.ccp-risk-page').insertBefore('footer.site-footer');
        }


        if ($('body').hasClass('page-id-844')) {
            $('.ccp-risk-page').insertBefore('footer.site-footer');
        }

        if ($('body').hasClass('page-id-2547')) {
            $('.ccp-risk-page').insertBefore('footer.site-footer');
        }


        if ($('body').hasClass('page-id-720')) {
            var $contactSection = $('.emir-contact');

            if ($contactSection.length) {
                $contactSection.wrap('<div class="container emir-contact-container"><div class="row"><div class="col-12"></div></div></div>');

                $('.emir-contact-container').insertBefore('footer.site-footer');
            }
        }

        if ($('body').hasClass('page-id-1061')) {
            $('.legal-content').insertBefore('footer.site-footer');
        }
    });

})(jQuery);





// Contact Form 7




(function($) {
    function initJurisdictions() {
        const $selectAll = $('#select-all-jurisdictions');

        if (!$selectAll.length) {
            setTimeout(initJurisdictions, 100);
            return;
        }

        function syncSelectAll() {
            const total = $('.jurisdiction-filter').length;
            const checked = $('.jurisdiction-filter:checked').length;
            $selectAll.prop('checked', total > 0 && total === checked);
        }

        $selectAll.on('change', function() {
            const isChecked = $(this).is(':checked');
            $('.jurisdiction-filter, .region-toggle').prop('checked', isChecked);
            // Show/hide all sections
            $('.jurisdiction-section').toggle(isChecked);
        });

        $('.region-toggle').on('change', function() {
            const regionSlug = $(this).data('region-target');
            const isChecked = $(this).is(':checked');
            $(`li[data-region-group="${regionSlug}"] .jurisdiction-filter`).prop('checked', isChecked);
            syncSelectAll();
        });

        $('.jurisdiction-filter').on('change', function() {
            syncSelectAll();
            // Filter content sections by jurisdiction slug
            const slug = $(this).val();
            const isChecked = $(this).is(':checked');
            $('[data-jurisdiction="' + slug + '"]').toggle(isChecked);
        });

        // Select all on init
        $selectAll.prop('checked', true).trigger('change');
    }

    $(document).ready(function() {
        setTimeout(initJurisdictions, 300);
    });
})(jQuery);

// ============================================================
// FIA Contact Us form -> Azure backend (sends user + admin emails)
// Paste at the bottom of custom-javascript.js
// ============================================================
jQuery(document).ready(function ($) {

    var $form = $('#fia-contact-form');
    if (!$form.length) return; // not on the contact page

    var apiUrl = '/api/ai/contact';

    var $btn = $form.find('.btn-send-message');
    var $btnText = $btn.find('.btn-text');
    var $spinner = $btn.find('.spinner-border');
    var $response = $form.find('.form-response-message');

    // Map the <select> values to readable service names for the email
    var serviceLabels = {
        global: 'Global Documentation',
        europe: 'European Documentation',
        us: 'US Documentation',
        ccp: 'CCP Risk Review'
    };

    function showResponse(message, isSuccess) {
        $response
            .removeClass('d-none')
            .css({
                padding: '12px 16px',
                'border-radius': '6px',
                'font-size': '0.95rem',
                color: isSuccess ? '#0f5132' : '#842029',
                'background-color': isSuccess ? '#d1e7dd' : '#f8d7da',
                border: '1px solid ' + (isSuccess ? '#badbcc' : '#f5c2c7')
            })
            .text(message);
    }

    function setLoading(loading) {
        if (loading) {
            $btn.prop('disabled', true);
            $btnText.text('Sending...');
            $spinner.removeClass('d-none');
        } else {
            $btn.prop('disabled', false);
            $btnText.text('Send Message');
            $spinner.addClass('d-none');
        }
    }

    function val(name) {
        return $.trim($form.find('[name="' + name + '"]').val() || '');
    }

    // Phone: optional leading "+", then 7–15 digits. Spaces, dashes, dots and
    // brackets are allowed as separators and ignored. Mirrors isValidPhone()
    // in the backend contact route.
    function isValidPhone(phone) {
        var digits = String(phone).replace(/[\s().-]/g, '');
        return /^\+?\d{7,15}$/.test(digits);
    }

    $form.on('submit', async function (e) {
        e.preventDefault();

        // Let the browser enforce required fields (including the consent checkbox)
        if (!this.checkValidity()) {
            this.reportValidity();
            return;
        }

        $response.addClass('d-none');

        // Honeypot: if this hidden field is filled, it's a bot — pretend success, send nothing.
        if (val('hp_phone') !== '') {
            showResponse('Thank you! Your message has been sent.', true);
            return;
        }

        // Consent checkbox must be ticked
        if (!$form.find('[name="consent"]').is(':checked')) {
            showResponse('Please agree to the processing of your information before submitting.', false);
            return;
        }

        var payload = {
            firstName: val('first_name'),
            lastName:  val('last_name'),
            phone:     val('phone'),
            company:   val('company_name'),
            email:     val('email'),
            service:   serviceLabels[val('regional')] || val('regional'),
            message:   val('message'),
            consent:   $form.find('[name="consent"]').is(':checked')
        };

        // Client-side validation (matches backend required fields)
        if (!payload.firstName || !payload.lastName || !payload.phone ||
            !payload.company || !payload.email || !payload.service) {
            showResponse('Please fill in all required fields.', false);
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
            showResponse('Please enter a valid email address.', false);
            return;
        }
        if (!isValidPhone(payload.phone)) {
            showResponse('Please enter a valid phone number (7–15 digits, optional leading +).', false);
            $form.find('[name="phone"]').trigger('focus');
            return;
        }

        setLoading(true);

        try {
            var res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            var data = await res.json().catch(function () { return {}; });

            if (res.ok && data.success) {
                showResponse('Thank you! Your message has been sent. Please check your inbox for a confirmation.', true);
                $form[0].reset();
                $form.find('.regional, select[name="regional"]').prop('selectedIndex', 0);
            } else if (res.status === 429) {
                showResponse(data.error || 'Too many requests. Please try again in a few minutes.', false);
            } else {
                showResponse(data.error || 'Something went wrong. Please try again later.', false);
            }
        } catch (err) {
            console.error('Contact form error:', err);
            showResponse('A server error occurred. Please try again later.', false);
        } finally {
            setLoading(false);
        }
    });
});